import { useState, React, useRef, useEffect, memo, useContext } from 'react';
import { NavbarSlotContext } from '../../../context/NavbarSlotContext';
import {
  Autocomplete,
  Avatar,
  AvatarGroup,
  CircularProgress,
  InputAdornment,
  LinearProgress,
  Menu,
  MenuItem,
  Select,
  Tooltip,
  Typography
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { useHistory } from 'react-router-dom';
import {
  CancelShipment,
  CheckLocation,
  CheckTrackingStatus,
  DispatchShipment,
  GetAagencyUserDetails,
  GetCarriers,
  GetClaimedShipmentDetails,
  GetShipmentActivity,
  GetShipmentDetails,
  GetShipments,
  HoldShipment,
  SaveUserSettings,
  TrackShipmentRequest,
  UnbookShipment,
  UnHoldShipment,
  UpdateShipment,
  UpdateShipmentLocation,
  UpdateTLShipment
} from '../../../apis/Agency';
import { useQuery } from '@tanstack/react-query';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CloudSyncRoundedIcon from '@mui/icons-material/CloudSyncRounded';
import { ErrorToast, successToast } from '../../../components/Toasts';
import { ToastContainer } from 'react-toastify';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import './ShipmentsTable.css';
import { useReactToPrint } from 'react-to-print';
import { useDispatch, useSelector } from 'react-redux';
import { base_logo_url, base_url } from '../../../apis/constants';
import {
  Badge,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import LaunchTwoToneIcon from '@mui/icons-material/LaunchTwoTone';
import PanToolTwoToneIcon from '@mui/icons-material/PanToolTwoTone';
import DisabledByDefaultTwoToneIcon from '@mui/icons-material/DisabledByDefaultTwoTone';
import { useMemo } from 'react';
import {
  MaterialReactTable,
  MRT_ToggleDensePaddingButton,
  MRT_FullScreenToggleButton,
  MRT_ShowHideColumnsButton
} from 'material-react-table';
import { Box, Button, IconButton } from '@mui/material';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import ViewShipment from '../../ViewShipment/ViewShipment';
import NoLogo from '../../../assets/carrier logos/No Logo.png';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import { useIsMobile } from '../../../components/IsMobileHook/IsMobileHook';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { DateRangeFilter } from '../../CustomDatePicker/CustomDatePicker';
import {
  formatDateUTCFormat,
  formatDateUTCRangeFilter
} from '../../../apis/Utils';
import { setShipmentDetails } from '../../../Redux/ViewShipmentsSlice';
// import ClaimDialog from '../../ClaimShipments';
import { Gavel } from '@mui/icons-material';
import CreateClaimModal from '../../CarrierClaimForm/CreateClaimModal';
import { MetaTags } from 'react-meta-tags';

const isHighlightedDate = (cellValue, filterValue) => {
  if (!filterValue || !filterValue[0] || !filterValue[1]) return false;

  const [startDate, endDate] = filterValue;
  const rowDate = new Date(cellValue);

  if (isNaN(rowDate)) return false;

  return rowDate >= new Date(startDate) && rowDate <= new Date(endDate);
};

const DateRangeHighlightCell = ({ cell, column }) => {
  const filterValue = column.getFilterValue() || [null, null]; // Safely get the filter value
  const cellValue = cell.getValue(); // Get the cell value

  const isHighlighted = isHighlightedDate(cellValue, filterValue); // Use the utility function

  return (
    <div
      style={{
        backgroundColor: isHighlighted ? 'rgb(255, 203, 127)' : 'transparent',
        padding: '4px',
        borderRadius: '4px',
        width: '50%',
        textAlign: 'center'
      }}
    >
      {cellValue}
    </div>
  );
};

const DateRangeSelector = ({
  column,
  dateField,
  tableCol = true,
  datesRange,
  setDatesRange,
  setDateFilter,
  handleResetPagination,
  onComplete
}) => {
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  const handleDateChange = update => {
    setDateRange(update || [null, null]);
    if (tableCol) {
      column.setFilterValue(update || [null, null]);
    } else {
      if (update[0] && update[1]) {
        handleResetPagination();
        setDatesRange({
          from: formatDateUTCRangeFilter(update[0]),
          to: formatDateUTCRangeFilter(update[1])
        });
        setDateFilter('Range');
        onComplete && onComplete();
      }
    }
  };

  return (
    <DatePicker
      isClearable={tableCol}
      selectsRange
      startDate={startDate}
      endDate={endDate}
      onChange={handleDateChange}
      popperPlacement='top-start'
      dateFormat='MMM d, yyyy'
      showYearDropdown
      showMonthDropdown
      scrollableYearDropdown
      yearDropdownItemNumber={15}
      placeholderText='Select date range'
      todayButton='Today'
      peekNextMonth
      showMonthYearPicker={false}
      showFullMonthYearPicker={false}
      className='custom-datepicker'
      calendarClassName='custom-calendar'
      wrapperClassName='datepicker-wrapper'
    />
  );
};

function ManageShipmentsTable(props) {
  const { setSlot } = useContext(NavbarSlotContext);
  const pickupDatepickerRef = useRef(null);
  const handlePickupDateIconClick = () => {
    if (pickupDatepickerRef.current) {
      pickupDatepickerRef.current.setFocus();

      if (pickupDatepickerRef.current.input) {
        pickupDatepickerRef.current.input.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  };
  const [expanded, setExpanded] = useState({});
  const UserIsAdmin = useSelector(state => state.userDetails.isAdmin);
  const [globalFilter, setGlobalFilter] = useState('');

  const [pagination, setPagination] = useState({
    pageIndex: 1,
    pageSize: 100
  });
  const [tenderedSubFilter, setTenderedSubFilter] = useState('all');
  const dateFIlterOptions = [
    'Today',
    'Last 7 Days',
    'Last 30 Days',
    'This Week',
    'Last Week',
    'This Month',
    'Last Month',
    'This Year',
    'Last Year',
    'Range'
  ];
  const getRollingBusinessWeekWindow = (date = new Date()) => {
    const targetDate = new Date(date);

    // Function to check if a day is a weekend
    const isWeekend = date => {
      const day = date.getDay();
      return day === 0 || day === 6; // 0 = Sunday, 6 = Saturday
    };

    // Function to get the next business day
    const getNextBusinessDay = (date, direction = 'backward') => {
      const newDate = new Date(date);

      if (direction === 'backward') {
        newDate.setDate(newDate.getDate() - 1);
        while (isWeekend(newDate)) {
          newDate.setDate(newDate.getDate() - 1);
        }
      } else {
        // forward
        newDate.setDate(newDate.getDate() + 1);
        while (isWeekend(newDate)) {
          newDate.setDate(newDate.getDate() + 1);
        }
      }

      return newDate;
    };

    // Find start date (3 business days before target date)
    let startDate = new Date(targetDate);
    for (let i = 0; i < 3; i++) {
      startDate = getNextBusinessDay(startDate, 'backward');
    }

    // Find end date (3 business days after target date)
    let endDate = new Date(targetDate);
    for (let i = 0; i < 3; i++) {
      endDate = getNextBusinessDay(endDate, 'forward');
    }

    // Reset times
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);

    return { startDate, endDate };
  };

  // Memoize rolling window
  const rollingWindow = useMemo(() => getRollingBusinessWeekWindow(), []);

  // Calculate 30 days ago date
  const thirtyDaysAgo = useMemo(() => {
    const date = new Date();
    date.setDate(date.getDate() - 30);
    return date;
  }, []);

  // Initialize date state
  const [datesRange, setDatesRange] = useState({
    from: formatDateUTCRangeFilter(rollingWindow.startDate),
    to: formatDateUTCRangeFilter(rollingWindow.endDate)
  });

  const [dateFilter, setDateFilter] = useState(dateFIlterOptions[3]);
  const [selectOpen, setSelectOpen] = useState(false);
  const justSelectedRangeRef = useRef(false);

  const handleDateFilterChange = (date, tabValue = value) => {
    const effectiveDate = date;

    if (effectiveDate === 'Range') {
      setDateFilter('Range');
      setDatesRange({ from: null, to: null });
      return;
    }

    let fromDate;
    let toDate = new Date();
    const bookedORTransit = tabValue === 2 || tabValue === 3;

    setNoRecordMsg('Loading ...');

    switch (effectiveDate) {
      case 'Today':
        fromDate = new Date();
        toDate = new Date();
        break;
      case 'This Week':
        // if (bookedORTransit) {
        fromDate = rollingWindow.startDate;
        toDate = rollingWindow.endDate;
        // }
        // else {
        //   fromDate = getStartOfWeek(new Date());
        //   toDate = new Date();
        // }
        break;
      case 'Last Week':
        const lastWeekStart = new Date();
        lastWeekStart.setDate(
          lastWeekStart.getDate() - lastWeekStart.getDay() - 7
        );
        const lastWeekEnd = new Date(lastWeekStart);
        lastWeekEnd.setDate(lastWeekStart.getDate() + 6);
        fromDate = lastWeekStart;
        toDate = lastWeekEnd;
        break;
      case 'This Month':
        fromDate = new Date(toDate.getFullYear(), toDate.getMonth(), 1);
        toDate = bookedORTransit ? new Date() : new Date();
        break;
      case 'Last Month':
        const lastMonthEnd = new Date(
          toDate.getFullYear(),
          toDate.getMonth(),
          0
        );
        const lastMonthStart = new Date(
          lastMonthEnd.getFullYear(),
          lastMonthEnd.getMonth(),
          1
        );
        fromDate = lastMonthStart;
        toDate = lastMonthEnd;
        break;
      case 'This Year':
        fromDate = new Date(toDate.getFullYear(), 0, 1);
        toDate = bookedORTransit ? new Date() : new Date();
        break;
      case 'Last Year':
        fromDate = new Date(toDate.getFullYear() - 1, 0, 1);
        toDate = new Date(toDate.getFullYear(), 0, 0);
        break;
      case 'Last 7 Days':
        fromDate = new Date();
        fromDate.setDate(fromDate.getDate() - 7);
        toDate = new Date();
        break;
      case 'Next 7 Days':
        fromDate = new Date();
        fromDate.setDate(fromDate.getDate() + 1);
        toDate = new Date();
        toDate.setDate(toDate.getDate() + 7);
        break;
      case 'Last 30 Days':
        fromDate = new Date();
        fromDate.setDate(fromDate.getDate() - 30);
        toDate = new Date();
        break;
      default:
        fromDate = toDate;
        break;
    }
    setDateFilter(effectiveDate);

    handleResetPagination();
    setDatesRange({
      from: formatDateUTCRangeFilter(fromDate),
      to: formatDateUTCRangeFilter(toDate)
    });
  };
  // useEffect(() => {
  //   handleResetPagination();
  // }, [dateFilter])

  const dispatch = useDispatch();
  // const [value, setValue] = useState(2);
  const tabMap = {
    Booked: 2,
    InTransit: 3,
    Delivered: 4
  };

  // Lazy initializer function for state
  const getInitialValue = () => {
    const selectedTab = props?.location?.state?.selectedTab;
    const { callAPI } = props || {};
    if (selectedTab === 'Booked' && callAPI === 'no') {
      return 2;
    }
    return tabMap[selectedTab] ?? 2; // fallback to Booked if no match
  };
  const [value, setValue] = useState(getInitialValue);

  const UserLoggedInEmail = useSelector(state => state.userDetails.email);
  const AgencyID = useSelector(state => state.userDetails.agencyLoginID);
  const userRolePermissions = useSelector(
    state => state.userDetails.userRolePermissionsArr
  );
  let TempApiNames = [];
  let TLTempApiNames = [];
  let ParcelTempApiNames = [];
  const [expandedDetail, setExpandedDetail] = useState(false);
  const [DateFilterModal, setDateFilterModal] = useState(false);
  const [shipmentsLoader, setShipmentsLoader] = useState(true);
  const [noRecordMsg, setNoRecordMsg] = useState('Loading ...');
  const [isLoading, setIsLoading] = useState(false);
  const [updateBOLDialg, setUpdateBOLDialg] = useState(false);
  const [, setBolUpdated] = useState(false);
  const [fetchTrackingLoaderState, setFetchTrackingLoaderState] = useState(
    sessionStorage.getItem('FetchTrackingLoader') === 'true'
  );
  const [totalShipmentsCount, setTotalShipmentsCount] = useState('');
  const [, setStatusLoader] = useState(false);
  const [viewShipmentsData, setViewShipmentsData] = useState([]);
  const [savedShipments, setSavedShipments] = useState('');
  const [tenderedShipments, setTenderedShipments] = useState('');
  const [bookedShipments, setBookedShipments] = useState('');
  const [inTransitShipments, setInTransitShipments] = useState('');
  const [deliveredShipments, setDeliveredShipments] = useState('');
  const [cancelledShipments, setCancelledShipments] = useState('');
  const [carrierApiNames, setCarrierApiNames] = useState([]);
  const [TlCarrierApiNames, setTlCarrierApiNames] = useState([]);
  const [ParcelCarrierApiNames, setParcelCarrierApiNames] = useState([]);
  const [, setTrackShipmentData] = useState();
  const [holdShipmentRemarks, setHoldShipmentRemarks] = useState('');
  const [updatedProNmb, setUpdatedProNmb] = useState('');
  const [updatedPickNmb, setUpdatedPickNmb] = useState('');
  const [updatedPickupDate, setUpdatedPickupDate] = useState(null);
  const [updatedDeliveryDate, setUpdatedDeliveryDate] = useState(null);
  const [updatedShipmentReason, setUpdatedShipmentReason] = useState('');
  const [markAsDeliverDate, setMarkAsDeliverDate] = useState(new Date());
  const [markAsDeliverTime, setMarkAsDeliverTime] = useState('');

  const [markDeliverDialog, setMarkDeliverDialog] = useState(false);
  const [openDeliverDialog, setOpenDeliverDialog] = useState(false);
  const [claimDialogOpen, setClaimDialogOpen] = useState(false);
  const [claimsData, setClaimsData] = useState(null);
  const [updateShipmentLoader, setUpdateShipmentLoader] = useState(false);
  const [markAsDeliverRowData, setMarkAsDeliverRowData] = useState('');
  const [addUpdateLocationDialog, setAddUpdateLocationDialog] = useState(false);
  const [addUpdateLocationID, setAddUpdateLocationID] = useState('');
  const [addUpdateLocationShipID, setAddUpdateLocationShipID] = useState('');
  const [userPermissionsArr, setUserPermissionsArr] = useState(null);
  const [agencyLocationsLoader] = useState(false);
  const [agencyLocations] = useState([]);
  const [, setUserLocations] = useState([]);
  const [clickedRowLocation] = useState('');
  const [checkLocIndex, setCheckLocIndex] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [applySearch, setApplySearch] = useState(true);
  const [filteredRowCount, setFilteredRowCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setFetchTrackingLoaderState(
        sessionStorage.getItem('FetchTrackingLoader') === 'true'
      );
    }, 500); // Check every 500ms

    return () => clearInterval(interval); // Cleanup
  }, []);

  const handleResetPagination = () => {
    setViewShipmentsData([]);
    setHasMore(true);
    setPagination({
      ...pagination,
      pageIndex: 1
    });
  };
  const handleRecordsChange = event => {
    // setRecordsPerPage(event.target.value);
    // if (event.target.value < viewShipmentsData.length) {
    setViewShipmentsData([]);
    setHasMore(true);
    // }
    setPagination({
      pageIndex: 1,
      pageSize: event.target.value
    });
  };

  const searchRef = useRef('');
  const inputRef = useRef(null); // Ref for directly updating the input field

  const handleSearchChange = (e, type) => {
    if (type === 'clear') {
      handleResetPagination();
      searchRef.current = '';
      setSearchQuery('');

      if (inputRef.current) inputRef.current.value = ''; // Reset input field

      if (!applySearch) setViewShipmentsData([]);
      setApplySearch(!applySearch);
    } else {
      searchRef.current = e.target.value;
    }
  };

  const searchGlobal = () => {
    setSearchQuery(searchRef.current);
    setViewShipmentsData([]);
    setShipmentsLoader(true);
    setApplySearch(!applySearch);
    setPagination({
      pageIndex: 1,
      pageSize: value === 2 || value === 3 ? 100 : value === 4 ? 1000 : 20
    });
  };

  const handleSearchKeyPress = e => {
    if (e.key === 'Enter') {
      searchGlobal();
    }
  };

  useEffect(() => {
    setSlot(
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          flexWrap: 'nowrap'
        }}
      >
        <Select
          size='small'
          open={selectOpen}
          onOpen={() => setSelectOpen(true)}
          onClose={() => {
            if (justSelectedRangeRef.current) {
              justSelectedRangeRef.current = false;
              return;
            }
            setSelectOpen(false);
          }}
          value={dateFilter}
          onChange={e => {
            if (e.target.value === 'Range') justSelectedRangeRef.current = true;
            handleDateFilterChange(e.target.value, null);
          }}
          renderValue={v => {
            if (v === 'Range' && datesRange.from) {
              const fmt = d => new Date(d + 'T00:00:00').toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
              return `Range (${fmt(datesRange.from)} to ${fmt(datesRange.to)})`;
            }
            return v;
          }}
          sx={{ minWidth: 150, height: 34, fontSize: 13, bgcolor: 'white' }}
          MenuProps={{
            PaperProps: { sx: { maxHeight: 'none', overflow: 'visible' } },
            MenuListProps: { sx: { maxHeight: 'none', py: 0 } }
          }}
        >
          {dateFIlterOptions.map((opt, i) =>
            opt === 'Range' ? (
              <MenuItem
                key={i}
                value='Range'
                className='d-flex flex-column align-items-start'
                onMouseDown={e => e.stopPropagation()}
                sx={{
                  fontSize: 13
                }}
              >
                <Typography sx={{ fontSize: 13, py: 0.5 }}>Range</Typography>
                {dateFilter === 'Range' && (
                  <div onClick={e => e.stopPropagation()}>
                    <DateRangeSelector
                      tableCol={false}
                      datesRange={datesRange}
                      setDatesRange={setDatesRange}
                      setDateFilter={setDateFilter}
                      handleResetPagination={handleResetPagination}
                      dateField='Select Range'
                      onComplete={() => setSelectOpen(false)}
                    />
                  </div>
                )}
              </MenuItem>
            ) : (
              <MenuItem key={i} value={opt} sx={{ fontSize: 13 }}>
                {opt}
              </MenuItem>
            )
          )}
        </Select>
        <TextField
          size='small'
          inputRef={inputRef}
          placeholder='Search…'
          onChange={e => handleSearchChange(e, '')}
          onKeyPress={handleSearchKeyPress}
          sx={{ width: { sm: 140, md: 200 }, bgcolor: 'white' }}
          InputProps={{
            sx: { height: 34, fontSize: 13 },
            endAdornment: searchRef.current ? (
              <IconButton
                size='small'
                edge='end'
                onClick={e => handleSearchChange(e, 'clear')}
              >
                <ClearIcon fontSize='small' />
              </IconButton>
            ) : null
          }}
        />
        <Button
          variant='contained'
          size='small'
          onClick={searchGlobal}
          sx={{
            height: 34,
            textTransform: 'none',
            whiteSpace: 'nowrap',
            fontSize: 13
          }}
        >
          Search
        </Button>
      </Box>
    );
    return () => setSlot(null);
  }, [dateFilter, datesRange, setSlot, selectOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (dateFilter === 'Range' && !datesRange.from) return;
    handleGetSynchDataRecords();
  }, [
    // eslint-disable-line react-hooks/exhaustive-deps
    pagination.pageIndex,
    pagination.pageSize,
    globalFilter,
    value,
    searchQuery,
    applySearch,
    datesRange.from,
    datesRange.to,
    tenderedSubFilter // ← add this
  ]);

  useEffect(() => {
    const filteredCarrierPermissions = userRolePermissions?.filter(
      items => items.permissionName === 'Manage-Shipments'
    );
    setUserPermissionsArr(filteredCarrierPermissions);
    console.log(filteredCarrierPermissions, 'userPermissionsArr');
  }, [userRolePermissions]);
  const updateViewShipmentsData = dataArr => {
    if (dataArr.length === 0) {
      setHasMore(false);
    }
    let temp = [];
    let DestinationData;
    let OriginData;
    for (let i = 0; i < dataArr.length; i++) {
      DestinationData =
        dataArr[i].destinationCompany +
        ' ' +
        dataArr[i].destinationCity +
        ' ' +
        dataArr[i].destinationState +
        ' ' +
        dataArr[i].destinationZipCode;

      OriginData =
        dataArr[i].originCompany +
        ' ' +
        dataArr[i].originCity +
        ' ' +
        dataArr[i].originState +
        ' ' +
        dataArr[i].originZipCode;
      temp.push({
        ...dataArr[i],
        OriginData: OriginData,
        destinationData: DestinationData
      });
    }
    if (pagination.pageIndex > 1) {
      setTimeout(() => {
        setViewShipmentsData(prevData => {
          const combinedData = [...prevData, ...temp];
          const uniqueData = Array.from(
            new Map(combinedData.map(item => [item.id, item])).values()
          );

          return uniqueData;
        });
      }, 0);
    } else {
      setTimeout(() => {
        setViewShipmentsData(temp);
      }, 0);
    }

    setShipmentsLoader(false);
    setIsLoading(false);
  };
  const handleCloseBolDialog = type => {
    setUpdateBOLDialg(type);
  };
  const handleSuccessShipDetails = async (res, type, updatedRow) => {
    if (type === 'BOL') {
      // Batch BOL updates
      Promise.resolve().then(() => {
        successToast('BOL updated Successfully!');
        handleCloseBolDialog();
        updateViewShipmentsData(res.data.data);
        setBolUpdated(true);
        setUpdateBOLDialg(false);
        setExpandedDetail(false);
      });
    } else {
      // Batch all state updates together
      Promise.resolve().then(() => {
        setTotalShipmentsCount(res.data.pagingInfo.totalCount);
        setTenderedShipments(res.data.pagingInfo.totalTendered);
        setSavedShipments(res.data.pagingInfo.totalSaved);
        setBookedShipments(res.data.pagingInfo.totalBooked);
        setInTransitShipments(res.data.pagingInfo.totalInTransit);
        setDeliveredShipments(res.data.pagingInfo.totalDelivered);
        setCancelledShipments(res.data.pagingInfo.totalCancelled);

        updateViewShipmentsData(res.data.data);

        dispatch(
          setShipmentDetails({
            totalShipments: res.data.pagingInfo.totalCount,
            tenderedShipments: res.data.pagingInfo.totalTendered,
            savedShipments: res.data.pagingInfo.totalSaved,
            bookedShipments: res.data.pagingInfo.totalBooked,
            transitShipments: res.data.pagingInfo.totalInTransit,
            deliveredShipments: res.data.pagingInfo.totalDelivered,
            cancelledShipments: res.data.pagingInfo.totalCancelled
          })
        );

        if (res.data.data.length === 0) {
          setNoRecordMsg('No Records');
        }
      });
    }
  };

  // 🟢 Here's the value state initialization

  useEffect(() => {
    const { selectedTab } = props || {};
    if (selectedTab && selectedTab in tabMap) {
      setTableCol(mtransitTabColumns);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleGetCarrierNames = data => {
    const LtlCarrierArray = data.filter(
      items => items.active && items.cType === 'LTL'
    );
    const TlCarrierArray = data.filter(
      items => items.active && items.cType === 'TL'
    );
    const ParcelCarrierArray = data.filter(
      items => items.active && items.cType === 'Parcel'
    );
    let TempApisEndPoint = [];

    for (let i = 0; i < LtlCarrierArray.length; i++) {
      const CarrierName = LtlCarrierArray[i]?.getRateEndPoint?.replace('/', '');
      const element = base_url + CarrierName;
      TempApisEndPoint.push(element);
    }
    for (let i = 0; i < LtlCarrierArray.length; i++) {
      const CarrierName = LtlCarrierArray[i].name;
      const ID = LtlCarrierArray[i].carrierId;
      // const CarrierLogo = LogoArray.find(
      //   items => items.name === LtlCarrierArray[i].logo
      // );

      const CarrierLogo = base_logo_url + LtlCarrierArray[i].logo;
      TempApiNames.push({
        title: CarrierName,
        carrierID: ID,
        carrierLogo: CarrierLogo
      });
    }
    TempApiNames.push({ title: 'Others', carrierID: '0', carrierLogo: '' });
    setCarrierApiNames(TempApiNames);
    for (let i = 0; i < TlCarrierArray.length; i++) {
      const CarrierName = TlCarrierArray[i]?.getRateEndPoint?.replace('/', '');
      const element = base_url + CarrierName;
      TempApisEndPoint.push(element);
    }
    for (let i = 0; i < TlCarrierArray.length; i++) {
      const CarrierName = TlCarrierArray[i].name;
      const ID = TlCarrierArray[i].carrierId;
      // const CarrierLogo = LogoArray.find(
      //   items => items.name === LtlCarrierArray[i].logo
      // );

      const CarrierLogo = base_logo_url + TlCarrierArray[i].logo;
      TLTempApiNames.push({
        title: CarrierName,
        carrierID: ID,
        carrierLogo: CarrierLogo
      });
    }
    TLTempApiNames.push({ title: 'Others', carrierID: '0', carrierLogo: '' });
    setTlCarrierApiNames(TLTempApiNames);
    for (let i = 0; i < ParcelCarrierArray.length; i++) {
      const CarrierName = ParcelCarrierArray[i]?.getRateEndPoint?.replace(
        '/',
        ''
      );
      const element = base_url + CarrierName;
      TempApisEndPoint.push(element);
    }
    for (let i = 0; i < ParcelCarrierArray.length; i++) {
      const CarrierName = ParcelCarrierArray[i].name;
      const ID = ParcelCarrierArray[i].carrierId;
      // const CarrierLogo = LogoArray.find(
      //   items => items.name === ParcelCarrierArray[i].logo
      // );

      const CarrierLogo = base_logo_url + ParcelCarrierArray[i].logo;
      ParcelTempApiNames.push({
        title: CarrierName,
        carrierID: ID,
        carrierLogo: CarrierLogo
      });
    }
    ParcelTempApiNames.push({
      title: 'Others',
      carrierID: '0',
      carrierLogo: ''
    });
    setParcelCarrierApiNames(ParcelTempApiNames);
  };
  const handleActiveTab = newValue => {
    if (newValue === 0) {
      return 'Saved';
    } else if (newValue === 1) {
      if (tenderedSubFilter === 'approved') {
        return 'ApprovedForBooking';
      } else {
        return 'Tendered';
      }
    } else if (newValue === 2) {
      return 'Booked';
    } else if (newValue === 3) {
      return 'InTransit';
    } else if (newValue === 4) {
      return 'Delivered';
    } else if (newValue === 5) {
      return 'Cancelled';
    }
  };

  const handleGetSynchDataRecords = (type, updatedRow) => {
    // setShipmentsLoader(true);
    // setViewShipmentsData([]);
    if (type === 'BOL') {
      setIsLoading(true);
    }

    // const lowercaseFilter = String(globalFilter).toLowerCase();
    GetShipments(
      AgencyID,
      UserLoggedInEmail,
      type === 'BOL' ? 1 : pagination.pageIndex,
      pagination.pageSize,
      searchQuery,
      handleActiveTab(value),
      datesRange
    )
      .then(
        res =>
          res.status === 200 && handleSuccessShipDetails(res, type, updatedRow)
      )
      .catch(err => {
        // setShipmentsLoader(false);
        setHasMore(false);
      });
  };

  const { data: carriersData, isLoading: carriersLoading } = useQuery({
    queryKey: ['carriers', AgencyID],
    queryFn: () => GetCarriers(AgencyID).then(res => res.data.data),
    enabled: !!AgencyID, // Only run if AgencyID exists
    staleTime: 5 * 60 * 1000 // Cache for 5 minutes
  });

  // 3. Add this useEffect to process carriers when data arrives
  useEffect(() => {
    if (carriersData && !carriersLoading) {
      handleGetCarrierNames(carriersData);
    }
  }, [carriersData, carriersLoading]); // eslint-disable-line react-hooks/exhaustive-deps

  // 4. Remove the old GetCarriers call from the other useEffect
  useEffect(() => {
    if (UserLoggedInEmail) {
      FetchCurrentUserDetails();
      // REMOVE GetCarriers from here
    }
  }, [UserLoggedInEmail]); // eslint-disable-line react-hooks/exhaustive-deps

  const history = useHistory();

  // const tableRef = useRef();

  const [onclickSelectedRow, setOnclickSelectedRow] = useState('');

  !onclickSelectedRow === null &&
    setTimeout(() => {
      setOnclickSelectedRow(null);
    }, 5000);

  const shipmentStatusColor = shipmentStatus => {
    if (shipmentStatus === 'Saved') {
      return { color: '#448aff', backgroundColor: '#bbdefb' };
    }
    if (shipmentStatus.toUpperCase() === 'HOLD') {
      return { color: '#d50000', backgroundColor: '#ffebee' };
    }
    if (shipmentStatus === 'Booked') {
      return { color: '#9c27b0', backgroundColor: '#f3e5f5' };
    }
    if (shipmentStatus === 'Delivered') {
      return { color: '#1b5e20', backgroundColor: '#c8e6c9' };
    }
    if (shipmentStatus === 'InTransit') {
      return { color: '#e65100', backgroundColor: '#ffe0b2' };
    }
    if (shipmentStatus === 'ApprovedForBooking') {
      return { color: '#0277bd', backgroundColor: '#e1f5fe' };
    }
    if (shipmentStatus === 'Tendered') {
      return { color: '#e65100', backgroundColor: '#fff3e0' };
    }
    if (shipmentStatus === 'NotApproved') {
      return { color: '#c62828', backgroundColor: '#ffebee' };
    }
    // fallback for any unknown status
    return { color: '#424242', backgroundColor: '#eeeeee' };
  };

  const rando = max => Math.floor(Math.random() * max);
  const words = ['Paper', 'Rock', 'Scissors'];
  const rawData = [];

  for (let i = 0; i < 100; i++)
    rawData.push({ id: rando(300), name: words[i % words.length] });
  // const [, setForceUpdate] = useState(0);

  const componentRef = useRef();
  // const handlePrint = useReactToPrint({
  //   content: () =>
  //     componentRef?.current?.childNodes[2]?.childNodes[0]?.children[1]
  //       ?.children[0]
  // });

  const handleFetchLatestTrackShipments = () => {
    // setFetchTrackingLoader(true);
    sessionStorage.setItem('FetchTrackingLoader', 'true');
    CheckTrackingStatus()
      .then(res => {
        res.status === 200 &&
          successToast('Tracking Statuses Updated Successfully!');
        // setFetchTrackingLoader(false);
        sessionStorage.setItem('FetchTrackingLoader', 'false');
        handleGetSynchDataRecords();
      })
      .catch(err => ErrorToast(err?.message));
  };
  const handlePrint = useReactToPrint({
    content: () => {
      if (componentRef?.current) {
        const tableToPrint = componentRef.current
          .querySelector('table')
          .cloneNode(true);

        if (tableToPrint) {
          // Remove unwanted header cells
          const headerRow = tableToPrint.querySelector('thead tr');
          if (headerRow) {
            for (let i = 0; i < 3; i++) {
              if (headerRow.firstElementChild) {
                headerRow.removeChild(headerRow.firstElementChild);
              }
            }
          }

          // Remove specific data cells in each row
          const dataRows = tableToPrint.querySelectorAll('tbody tr');
          dataRows.forEach(row => {
            for (let i = 0; i < 3; i++) {
              if (row.firstElementChild) {
                row.removeChild(row.firstElementChild);
              }
            }
          });

          // Locate and remove filter input elements within header cells
          const headerCells = tableToPrint.querySelectorAll('thead th');
          headerCells.forEach(cell => {
            const filterElements = cell.querySelectorAll(
              'input, select, .MuiFormControl-root'
            );
            filterElements.forEach(filter => filter.remove());
          });

          // Wrap the modified table in a container for printing
          const printContainer = document.createElement('div');
          printContainer.className = 'print-container'; // Apply CSS class if needed
          printContainer.style.margin = '0';
          printContainer.style.padding = '0';
          printContainer.style.overflow = 'hidden';
          printContainer.appendChild(tableToPrint);

          return printContainer;
        }
      }
      return null;
    }
  });

  const handleActionBtn = (detailsResponse, rowData, row, dialogName) => {
    rowData.details = detailsResponse;
    if (rowData.shipmentType === 'TL') {
      console.log(rowData.quoteId, dialogName, 'dialogName');
      if (dialogName === 'TenderTL') {
        // GetQuote(rowData.quoteId)
        //   .then(
        //     res =>
        //       res.status === 200 &&
        history.push({
          pathname: '/bookshipmentTL',
          state: {
            pickupRowData: JSON.stringify(rowData),
            disptachOpen: 'Get Quote',
            carrierApiNames: TlCarrierApiNames,
            apiData: rowData,
            userLocationsArr: []
          }
        });
        // )
        // .catch(err => console.log(err, 'GetQuoteErr------>'));
      }
      if (dialogName === 'Get Quote') {
        CheckLocation(rowData.shipmentId)
          .then(res => {
            if (res.status === 200 && res.data.data.valid) {
              setShipmentsLoader(false);

              history.push({
                pathname: '/bookshipmentTL',
                state: {
                  pickupRowData: JSON.stringify(rowData),
                  disptachOpen: 'Get Quote',
                  carrierApiNames: ParcelCarrierApiNames,
                  paymentType: res.data.data.paymentType,
                  locationId: res.data.data.locationId
                }
              });
            } else if (res.status === 200 && !res.data.data.valid) {
              setShipmentsLoader(false);

              ErrorToast(
                'No location Mapped against this shipment, please assign or create location!'
              );
              setTimeout(() => {
                history.push({
                  pathname: '/view-locations',
                  search: `?shipmentId=${rowData.shipmentId}`,
                  state: {
                    shipmentId: rowData.shipmentId
                  }
                });
              }, 3000);
            }
          })
          .catch(err => {
            setShipmentsLoader(false);

            ErrorToast(err?.message);
          });
      }

      if (dialogName === 'PickUp') {
        history.push({
          pathname: '/bookshipmentTL',
          state: {
            pickupRowData: JSON.stringify(rowData),
            disptachOpen: 'PickUp',
            carrierApiNames: TlCarrierApiNames
            // // : rowData
          }
        });
      }

      if (dialogName === 'Dispatch') {
        // event.stopPropagation();

        if (rowData?.shipmentStatus.toUpperCase() === 'HOLD') {
          GetShipmentActivity(rowData.shipmentId)
            .then(res => {
              res.status === 200 && res.data.data[0].acrionDetail
                ? ErrorToast(
                    `Shipment cannot be Disptached due to the reason, '${res.data.data[0].acrionDetail}'.`
                  )
                : ErrorToast(
                    'Shipment current status is HOLD, cannot be Disptached!.'
                  );
              setShipmentsLoader(false);
            })
            .catch(err =>
              ErrorToast(
                'Shipment current status is HOLD, cannot be Disptached!'
              )
            );
        } else {
          history.push({
            pathname: '/dispatchshipmentTL',
            state: {
              pickupRowData: JSON.stringify(rowData),
              disptachOpen: 'Dispatch',
              carrierApiNames: TlCarrierApiNames
            }
          });
        }
      }
    } else if (rowData.shipmentType === 'Parcel') {
      if (dialogName === 'Get Quote') {
        // history.push({
        //   pathname: '/bookshipmentParcel',
        //   state: {
        //     pickupRowData: JSON.stringify(rowData),
        //     disptachOpen: 'Get Quote',
        //     carrierApiNames: ParcelCarrierApiNames
        //     // // : rowData
        //   }
        // });
        CheckLocation(rowData.shipmentId)
          .then(res => {
            if (res.status === 200 && res.data.data.valid) {
              setShipmentsLoader(false);
              history.push({
                pathname: '/bookshipmentParcel',
                state: {
                  pickupRowData: JSON.stringify(rowData),
                  disptachOpen: 'Get Quote',
                  carrierApiNames: ParcelCarrierApiNames,
                  paymentType: res.data.data.paymentType,
                  locationId: res.data.data.locationId
                }
              });
            } else if (res.status === 200 && !res.data.data.valid) {
              setShipmentsLoader(false);

              ErrorToast(
                'No location Mapped against this shipment, please assign or create location!'
              );
              setShipmentsLoader(false);

              setTimeout(() => {
                history.push({
                  pathname: '/view-locations',
                  search: `?shipmentId=${rowData.shipmentId}`,
                  state: {
                    shipmentId: rowData.shipmentId
                  }
                });
              }, 3000);
            }
          })
          .catch(err => {
            setShipmentsLoader(false);

            ErrorToast(err?.message);
          });
      }

      if (dialogName === 'PickUp') {
        history.push({
          pathname: '/bookshipmentParcel',
          state: {
            pickupRowData: JSON.stringify(rowData),
            disptachOpen: 'PickUp',
            carrierApiNames: ParcelCarrierApiNames
          }
        });
      }

      if (dialogName === 'Dispatch') {
        // event.stopPropagation();
        if (rowData?.shipmentStatus.toUpperCase() === 'HOLD') {
          GetShipmentActivity(rowData.shipmentId)
            .then(res => {
              res.status === 200 && res.data.data[0].acrionDetail
                ? ErrorToast(
                    `Shipment cannot be Disptached due to the reason, '${res.data.data[0].acrionDetail}'.`
                  )
                : ErrorToast(
                    'Shipment current status is HOLD, cannot be Disptached!.'
                  );
              setShipmentsLoader(false);
            })
            .catch(err =>
              ErrorToast(
                'Shipment current status is HOLD, cannot be Disptached!'
              )
            );
        } else {
          history.push({
            pathname: '/dispatchshipmentParcel',
            state: {
              pickupRowData: JSON.stringify(rowData),
              disptachOpen: 'Dispatch',
              carrierApiNames: ParcelCarrierApiNames
              // assignedProNumber: res.data.data
            }
          });
          // GetNextProNumber(AgencyID, rowData.carrierId)
          //   .then(
          //     res =>
          //       res.status === 200 &&
          //       history.push({
          //         pathname: '/bookshipmentParcel',
          //         state: {
          //           pickupRowData: JSON.stringify(rowData),
          //           disptachOpen: 'Dispatch',
          //           carrierApiNames: ParcelCarrierApiNames,
          //           assignedProNumber: res.data.data
          //         }
          //       })
          //   )
          //   .catch(err =>
          //     history.push({
          //       pathname: '/bookshipmentParcel',
          //       state: {
          //         pickupRowData: JSON.stringify(rowData),
          //         disptachOpen: 'Dispatch',
          //         carrierApiNames: ParcelCarrierApiNames,
          //         assignedProNumber: ''
          //       }
          //     })
          //   );
        }
      }
    } else {
      if (dialogName === 'Get Quote') {
        CheckLocation(rowData.shipmentId)
          .then(res => {
            if (res.status === 200 && res.data.data.valid) {
              setShipmentsLoader(false);

              history.push({
                pathname: '/bookshipment',
                state: {
                  pickupRowData: JSON.stringify(rowData),
                  disptachOpen: 'Get Quote',
                  carrierApiNames: carrierApiNames,
                  paymentType: res.data.data.paymentType,
                  locationId: res.data.data.locationId,
                  origin: ''
                }
              });
            } else if (res.status === 200 && !res.data.data.valid) {
              setShipmentsLoader(false);

              ErrorToast(
                'No location Mapped against this shipment, please assign or create location!'
              );
              setTimeout(() => {
                history.push({
                  pathname: '/view-locations',
                  search: `?shipmentId=${rowData.shipmentId}`,
                  state: {
                    shipmentId: rowData.shipmentId
                  }
                });
              }, 3000);
            }
          })
          .catch(err => {
            setShipmentsLoader(false);

            ErrorToast(err?.message);
          });
      }

      if (dialogName === 'PickUp') {
        history.push({
          pathname: '/bookshipment',
          state: {
            pickupRowData: JSON.stringify(rowData),
            disptachOpen: 'PickUp',
            carrierApiNames: carrierApiNames,
            origin: ''
          }
        });
      }

      if (dialogName === 'Dispatch') {
        // event.stopPropagation();
        if (rowData?.shipmentStatus.toUpperCase() === 'HOLD') {
          GetShipmentActivity(rowData.shipmentId)
            .then(res => {
              res.status === 200 && res.data.data[0].acrionDetail
                ? ErrorToast(
                    `Shipment cannot be Disptached due to the reason, '${res.data.data[0].acrionDetail}'.`
                  )
                : ErrorToast(
                    'Shipment current status is HOLD, cannot be Disptached!.'
                  );
              setShipmentsLoader(false);
            })
            .catch(err =>
              ErrorToast(
                'Shipment current status is HOLD, cannot be Disptached!'
              )
            );
        } else {
          // GetNextProNumber(AgencyID, rowData.carrierId)
          //   .then(
          //     res =>
          //       res.status === 200 &&
          history.push({
            pathname: '/dispatchshipmentLTL',
            state: {
              pickupRowData: JSON.stringify(rowData),
              disptachOpen: 'Dispatch',
              carrierApiNames: carrierApiNames,
              assignedProNumber: ''
            }
          });
        }
      }
    }
  };
  const handlePickupOpen = (rowData, row, dialogName) => {
    setCheckLocIndex(row.index);
    setShipmentsLoader(true);
    GetShipmentDetails(rowData.shipmentId)
      .then(
        res =>
          res.status === 200 &&
          handleActionBtn(res.data.data, rowData, row, dialogName)
      )
      .catch(err => ErrorToast(err?.message));
    // event.stopPropagation();
  };
  const logTlRequestDateHandler = (dateString, time = '') => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    return time ? `${formattedDate} ${time}` : formattedDate;
  };

  const markAsDeliverRequest = () => {
    const DispatchObj = {
      shipmentId: markAsDeliverRowData.shipmentId
        ? markAsDeliverRowData.shipmentId
        : 0,
      agencyId: AgencyID ? AgencyID : 0,
      type: 1,
      proNumber: markAsDeliverRowData.proNumber
        ? markAsDeliverRowData.proNumber
        : '',
      bolNumber: markAsDeliverRowData.bolNumber
        ? markAsDeliverRowData.bolNumber
        : '',
      refNumber: '',
      pickupNumber: markAsDeliverRowData.pickupNumber
        ? markAsDeliverRowData.pickupNumber
        : '',
      carrierId: markAsDeliverRowData.carrierId
        ? markAsDeliverRowData.carrierId
        : 0,
      carrierName: markAsDeliverRowData.carrierName
        ? markAsDeliverRowData.carrierName
        : '',
      driverName: '',
      vehicleNumber: '',
      phoneNumber: '',
      deliveryDate: logTlRequestDateHandler(
        markAsDeliverDate,
        markAsDeliverTime
      )
    };
    handleClose();
    DispatchShipment(DispatchObj)
      .then(res => {
        res.status === 200 && successToast('Marked as Deliverd');
        handleTabChange('Delivered', 4);
        // setViewShipmentsData([]);
      })
      .catch(err => {
        ErrorToast(JSON.stringify(err?.message));
      });
  };

  const handleMarkDeliver = rowData => {
    // const CallDispatchShipmentApi = () => {
    // setPickUpLoader(true);
    setOpenHoldShipmentDialog(true);
    setMarkDeliverDialog(true);
    setMarkAsDeliverRowData(rowData);

    // };
  };
  const getClaimStatusColor = status => {
    switch (status) {
      case 'Submitted':
        return { color: '#1565c0', backgroundColor: '#bbdefb' };
      case 'Under Review':
        return { color: '#ef6c00', backgroundColor: '#ffe0b2' };
      case 'Awaiting Response':
        return { color: '#f57f17', backgroundColor: '#fff9c4' };
      case 'Accepted':
        return { color: '#1b5e20', backgroundColor: '#c8e6c9' };
      case 'Rejected':
        return { color: '#b71c1c', backgroundColor: '#ffcdd2' };
      case 'Paid':
        return { color: '#2e7d32', backgroundColor: '#c8e6c9' };
      case 'Unpaid':
        return { color: '#424242', backgroundColor: '#e0e0e0' };
      default:
        return { color: '#212121', backgroundColor: '#eeeeee' };
    }
  };

  const mtransitTabColumns = [
    {
      // accessorFn: row => `${row.carrierName} ${row.carrierLogo}`,
      accessorKey: 'carrierName',
      id: 'carrierName',
      header: 'Carrier Name',
      size: 50,
      minSize: 200,
      filterFn: (row, colID, filterValue) => {
        return row.original.carrierName
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ renderedCellValue, row }) => (
        <>
          {renderedCellValue && (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <AvatarGroup sx={{}} spacing='small'>
                <Avatar
                  sx={{
                    width: { xs: 30, sm: 40 },
                    height: { xs: 30, sm: 40 },
                    mx: { xs: 'auto', sm: 0 },
                    // background: 'linear-gradient(135deg, #46C8FF)',
                    borderRadius: '50%',
                    border: '1px solid #EEF6FB',
                    padding: '2px', // creates space for border effect
                    '& img': {
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                      borderRadius: '50%',
                      backgroundColor: '#fff',
                      border: '1px solid #E6F4FF', // very light border
                      boxShadow: '0 0 4px rgba(70, 200, 255, 0.35)' // soft glow
                    }
                  }}
                  // src={base_logo_url + carrier_logos/${items.logo}`}
                  src={
                    row.original.carrierLogo
                      ? base_logo_url + row.original.carrierLogo
                      : NoLogo
                  }
                />
              </AvatarGroup>
              <span>{renderedCellValue}</span>
              <br />
            </Box>
          )}
        </>
      )
    },
    {
      // accessorFn: (row) => `${row.soNumber}|${row.clientPONumber}`,
      accessorKey: 'proNumber',
      id: 'proNumber',
      header: 'PRO/Tracking #',
      size: 50,
      minSize: 200,
      filterFn: (row, colID, filterValue) => {
        return row.original.proNumber
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ renderedCellValue, row }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span>{renderedCellValue}</span>
            <br />
          </Box>
        </>
      )
    },
    {
      // accessorFn: (row) => `${row.soNumber}|${row.clientPONumber}`,
      accessorKey: 'bolNumber',
      id: 'bolNumber',
      header: 'BOL #',
      size: 50,
      minSize: 200,
      filterFn: (row, colID, filterValue) => {
        return row.original.bolNumber
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ renderedCellValue, row }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span>{renderedCellValue}</span>
            <br />
          </Box>
        </>
      )
    },
    {
      // accessorFn: (row) => `${row.soNumber}|${row.clientPONumber}`,
      accessorKey: 'soNumber',
      id: 'soNumber',
      header: 'Shipment #',
      size: 10,
      minSize: 200,
      filterFn: (row, colID, filterValue) => {
        return row.original.soNumber
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ renderedCellValue, row }) => (
        <>
          <Box>
            <span>{renderedCellValue}</span>
            {/* <br /> */}
          </Box>
        </>
      )
    },
    {
      accessorKey: 'shipmentStatus',
      id: 'shipmentStatus',
      header: 'Shipment Status',
      size: 50,
      minSize: 200,

      Cell: ({ renderedCellValue, row }) => (
        <>
          <Box>
            <Chip
              sx={shipmentStatusColor(row?.original?.shipmentStatus)}
              label={renderedCellValue}
            />
          </Box>
        </>
      )
    },

    {
      accessorKey: 'claimStatus',
      id: 'claimStatus',
      header: 'Claim Status',
      size: 50,
      minSize: 200,
      Cell: ({ renderedCellValue }) =>
        renderedCellValue && (
          <Box>
            <Chip
              label={renderedCellValue}
              sx={getClaimStatusColor(renderedCellValue)}
            />
          </Box>
        )
    },
    {
      // accessorFn: (row) => `${row.shipmentType}|${row.shipmentStatus}`,
      accessorKey: 'shipmentType',
      id: 'shipmentType',
      header: 'Shipment Mode',
      size: 70,
      minSize: 200,
      filterFn: (row, colID, filterValue) => {
        return row.original.shipmentType
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ renderedCellValue, row }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Chip
              sx={{ backgroundColor: '#E1F5FE', color: '#01579B' }}
              label={renderedCellValue}
            />
          </Box>
        </>
      )
    },
    {
      // accessorFn: (row) => `${row.shipmentType}|${row.shipmentStatus}`,
      accessorKey: 'createdOn',
      id: 'createdOn',
      header: 'Created On',
      size: 70,
      minSize: 240,
      enableColumnFilter: true,
      filterFn: (row, columnId, filterValue) => {
        if (!filterValue || !filterValue[0] || !filterValue[1]) {
          setColumnFilters(
            prevFilters =>
              prevFilters.filter(filter => filter.id !== 'createdOn') // Remove only this column filter
          );
          return true;
        }

        const rowDate = new Date(row.original.createdOn);
        if (isNaN(rowDate)) {
          return false;
        }

        const [startDate, endDate] = filterValue;
        return rowDate >= startDate && rowDate <= endDate;
      },
      Filter: ({ column }) => (
        <DateRangeSelector
          column={column}
          dateField='Created On'
          // clearFilter={() => column.setFilterValue([])}
        />
      ),
      Cell: DateRangeHighlightCell
    },
    {
      // accessorFn: (row) => `${row.shipmentType}|${row.shipmentStatus}`,
      accessorKey: 'quoteNumber',
      id: 'quoteNumber',
      header: 'Quote Number',
      size: 70,
      minSize: 200,
      filterFn: (row, colID, filterValue) => {
        return row.original.quoteNumber
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ renderedCellValue, row }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {renderedCellValue}
          </Box>
        </>
      )
    },

    {
      accessorKey: 'pickupDate',
      id: 'pickupDate',
      header: 'Requested Pickup Date',
      size: 250,
      minSize: 200,
      filterFn: (row, columnId, filterValue) => {
        if (!filterValue || !filterValue[0] || !filterValue[1]) {
          setColumnFilters(
            prevFilters =>
              prevFilters.filter(filter => filter.id !== 'pickupDate') // Remove only this column filter
          );
          return true;
        }

        const rowDate = new Date(row.original.pickupDate);
        if (isNaN(rowDate)) return false;

        const [startDate, endDate] = filterValue;
        return rowDate >= startDate && rowDate <= endDate;
      },
      Filter: ({ column }) => (
        <DateRangeSelector column={column} dateField='Pickup Date' />
      ),
      Cell: DateRangeHighlightCell
    },
    {
      accessorKey: 'actualPickupDate',
      id: 'actualPickupDate',
      header: 'Actual Pickup Date',
      size: 250,
      minSize: 200,
      filterFn: (row, columnId, filterValue) => {
        if (!filterValue || !filterValue[0] || !filterValue[1]) {
          setColumnFilters(
            prevFilters =>
              prevFilters.filter(filter => filter.id !== 'actualPickupDate') // Remove only this column filter
          );
          return true;
        }

        const rowDate = new Date(row.original.actualPickupDate);
        if (isNaN(rowDate)) return false;

        const [startDate, endDate] = filterValue;
        return rowDate >= startDate && rowDate <= endDate;
      },
      Filter: ({ column }) => (
        <DateRangeSelector column={column} dateField='Actual Pickup Date' />
      ),
      Cell: DateRangeHighlightCell
    },
    {
      accessorKey: 'deliveryDate',
      id: 'deliveryDate',
      header: 'Est Delivery Date',
      size: 250,
      minSize: 200,
      filterFn: (row, columnId, filterValue) => {
        if (!filterValue || !filterValue[0] || !filterValue[1]) {
          setColumnFilters(
            prevFilters =>
              prevFilters.filter(filter => filter.id !== 'deliveryDate') // Remove only this column filter
          );
          return true;
        }

        const rowDate = new Date(row.original.deliveryDate);
        if (isNaN(rowDate)) return false;

        const [startDate, endDate] = filterValue;
        return rowDate >= startDate && rowDate <= endDate;
      },
      Filter: ({ column }) => (
        <DateRangeSelector column={column} dateField='Est Delivery Date' />
      ),
      Cell: DateRangeHighlightCell
    },
    {
      accessorKey: 'actualDeliveryDate',
      id: 'actualDeliveryDate',
      header: 'Actual Delivery Date',
      size: 250,
      minSize: 200,
      filterFn: (row, columnId, filterValue) => {
        if (!filterValue || !filterValue[0] || !filterValue[1]) {
          setColumnFilters(
            prevFilters =>
              prevFilters.filter(filter => filter.id !== 'actualDeliveryDate') // Remove only this column filter
          );
          return true;
        }

        const rowDate = new Date(row.original.actualDeliveryDate);
        if (isNaN(rowDate)) return false;

        const [startDate, endDate] = filterValue;
        return rowDate >= startDate && rowDate <= endDate;
      },

      Filter: ({ column }) => (
        <DateRangeSelector column={column} dateField='Actual Delivery Date' />
      ),
      Cell: DateRangeHighlightCell
    },

    {
      accessorKey: 'originCompany',
      id: 'originCompany', //id is still required when using accessorFn instead of accessorKey
      header: 'Origin Company',
      size: 50,
      minSize: 200,
      filterFn: (row, colID, filterValue) => {
        return row.original.originCompany
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ cell }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {cell.getValue()}
          </Box>
        </>
      )
    },
    {
      accessorKey: 'originZipCode',
      id: 'originZipCode', //id is still required when using accessorFn instead of accessorKey
      header: 'Origin Zip',
      size: 50,
      minSize: 200,
      filterFn: (row, colID, filterValue) => {
        return row.original.originZipCode
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ cell }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {cell.getValue()}
          </Box>
        </>
      )
    },
    {
      accessorKey: 'originCity',
      id: 'originCity', //id is still required when using accessorFn instead of accessorKey
      header: 'Origin City',
      size: 50,
      minSize: 200,
      filterFn: (row, colID, filterValue) => {
        return row.original.originCity
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ cell }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {cell.getValue()}
          </Box>
        </>
      )
    },

    {
      accessorKey: 'originState',
      id: 'originState', //id is still required when using accessorFn instead of accessorKey
      header: 'Origin State',
      size: 50,
      minSize: 200,
      filterFn: (row, colID, filterValue) => {
        return row.original.originState
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ cell }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {cell.getValue()}
          </Box>
        </>
      )
    },
    {
      accessorKey: 'destinationCompany',
      id: 'destinationCompany', //id is still required when using accessorFn instead of accessorKey
      header: 'Destination Company',
      size: 50,
      minSize: 200,
      filterFn: (row, colID, filterValue) => {
        return row.original.destinationCompany
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ cell }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {cell.getValue()}
          </Box>
        </>
      )
    },
    {
      accessorKey: 'destinationZipCode',
      id: 'destinationZipCode', //id is still required when using accessorFn instead of accessorKey
      header: 'Destination Zip',
      size: 50,
      minSize: 200,
      filterFn: (row, colID, filterValue) => {
        return row.original.destinationZipCode
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ cell }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {cell.getValue()}
          </Box>
        </>
      )
    },
    {
      accessorKey: 'destinationCity',
      id: 'destinationCity', //id is still required when using accessorFn instead of accessorKey
      header: 'Destination City',
      size: 50,
      minSize: 200,
      filterFn: (row, colID, filterValue) => {
        return row.original.destinationCity
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ cell }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {cell.getValue()}
          </Box>
        </>
      )
    },
    {
      accessorKey: 'destinationState',
      id: 'destinationState', //id is still required when using accessorFn instead of accessorKey
      header: 'Destination State',
      size: 50,
      minSize: 200,
      filterFn: (row, colID, filterValue) => {
        return row.original.destinationState
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ cell }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {cell.getValue()}
          </Box>
        </>
      )
    },
    {
      accessorKey: 'billToCompany',
      id: 'billToCompany', //id is still required when using accessorFn instead of accessorKey
      header: 'Bill To Company ',
      size: 50,
      minSize: 200,
      filterFn: (row, colID, filterValue) => {
        return row.original.billToCompany
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ cell }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {cell.getValue()}
          </Box>
        </>
      )
    },
    {
      accessorKey: 'shipmentCharges',
      id: 'shipmentCharges',
      header: 'Carrier Total Rate',
      size: 50,
      minSize: 200,
      filterFn: (row, colID, filterValue) => {
        const shipmentCharges = parseFloat(row.original.shipmentCharges); // Convert to a number
        if (isNaN(shipmentCharges)) return false; // Skip rows with invalid numbers

        // Check if the filterValue is part of the shipmentCharges string representation
        return shipmentCharges.toString().includes(filterValue);
      },
      Cell: ({ row, table }) => {
        const rawValue = row.original.shipmentCharges; // Get raw, unformatted value
        const formattedValue = parseFloat(rawValue); // Parse the raw value

        const filterValue =
          table.getColumn('shipmentCharges').getFilterValue() || ''; // Get the current filter value
        const isHighlighted =
          filterValue && formattedValue.toString().includes(filterValue);

        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <span
              style={
                isHighlighted ? { backgroundColor: 'rgb(255, 203, 127)' } : {}
              }
            >
              {!isNaN(formattedValue)
                ? `$${formattedValue.toFixed(2)}`
                : '$0.00'}
            </span>
          </Box>
        );
      }
    },

    {
      // accessorFn: (row) => `${row.shipmentType}|${row.shipmentStatus}`,
      accessorKey: 'freightTerms',
      id: 'freightTerms',
      header: <div style={{ whiteSpace: 'nowrap' }}>Carrier Freight Terms</div>,
      minSize: 240,
      filterFn: (row, colID, filterValue) => {
        return row.original.freightTerms
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ renderedCellValue, row }) => (
        <>
          {row.original.shipmentType !== 'TL' && (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {renderedCellValue === 'C' ? (
                <Chip
                  sx={{ backgroundColor: '#E8F5E9', color: '#1B5E20' }}
                  label={renderedCellValue}
                />
              ) : renderedCellValue === 'PP' ? (
                <Chip
                  sx={{ backgroundColor: '#E1F5FE', color: '#01579B' }}
                  label={renderedCellValue}
                />
              ) : renderedCellValue === 'P' ? (
                <Chip
                  sx={{ backgroundColor: '#FCE4EC', color: '#B71C1C' }}
                  label={renderedCellValue}
                />
              ) : (
                <Chip
                  sx={{ backgroundColor: '#00000014', color: '#00000099' }}
                  label={renderedCellValue}
                />
              )}
            </Box>
          )}
        </>
      )
    },
    {
      // accessorFn: (row) => `${row.details[0].pallets}`,
      accessorKey: 'totalGrossWeight',
      id: 'totalGrossWeight',
      header: 'Total Gross Weight',
      size: 50,
      minSize: 200,
      // filterFn: (row, colID, filterValue) => {
      //   return row.original.customerId
      //     .toLowerCase()
      //     .includes(filterValue.toLowerCase());
      // },
      Cell: ({ renderedCellValue, row }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span>{renderedCellValue}</span>
            <br />
          </Box>
        </>
      )
    },

    {
      // accessorFn: (row) => `${row.shipmentType}|${row.shipmentStatus}`,
      accessorKey: 'paymentTerms',
      id: 'paymentTerms',
      minSize: 200,
      header: (
        <div style={{ whiteSpace: 'nowrap' }}>Customer Freight Terms</div>
      ),
      size: 70,
      filterFn: (row, colID, filterValue) => {
        return row.original.paymentTerms
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ renderedCellValue, row }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span>{renderedCellValue}</span>
            <br />
          </Box>
        </>
      )
    },

    {
      accessorKey: 'shippingNotes',
      id: 'shippingNotes',
      header: 'Shipping Notes',
      size: 10,
      minSize: 200,

      // Pre-process the value for consistent filtering
      filterFn: (row, colID, filterValue) => {
        const rawValue = row.original?.shippingNotes || '';
        const plainText = rawValue.replace(/<\/?[^>]+(>|$)|&nbsp;/g, '').trim(); // Strip HTML tags
        return plainText.toLowerCase().includes(filterValue.toLowerCase());
      },

      // Render pre-processed value with conditional background styling
      Cell: ({ row, table }) => {
        // Access the current filter value for this column
        const filterValue =
          table
            .getState()
            .columnFilters.find(filter => filter.id === 'shippingNotes')
            ?.value || '';

        // Safely access the original value
        const rawValue = row.original?.shippingNotes || '';
        const plainText = rawValue.replace(/<\/?[^>]+(>|$)|&nbsp;/g, '').trim(); // Strip HTML tags only once

        // Check if the value matches the filter
        const isFiltered =
          filterValue &&
          plainText.toLowerCase().includes(filterValue.toLowerCase());

        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: isFiltered
                ? 'rgb(255, 203, 127)'
                : 'transparent', // Highlight if filtered
              padding: '4px',
              borderRadius: '4px'
            }}
          >
            <span>{plainText}</span>
          </Box>
        );
      }
    },
    {
      // accessorFn: (row) => `${row.shipmentType}|${row.shipmentStatus}`,
      accessorKey: 'locationName',
      id: 'locationName',
      header: 'Location Name',
      size: 10,
      minSize: 200,
      filterFn: (row, colID, filterValue) => {
        return row.original.locationName
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ renderedCellValue, row }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span>{renderedCellValue}</span>
            <br />
          </Box>
        </>
      )
    },
    {
      // accessorFn: (row) => `${row.soNumber}|${row.clientPONumber}`,
      accessorKey: 'clientPONumber',
      id: 'clientPONumber',
      header: 'PO#',
      size: 50,
      minSize: 200,
      filterFn: (row, colID, filterValue) => {
        return row.original.clientPONumber
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ renderedCellValue, row }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span>{renderedCellValue}</span>
            <br />
          </Box>
        </>
      )
    },
    {
      // accessorFn: (row) => `${row.details[0].pallets}`,
      accessorKey: 'customerId',
      id: 'customerId',
      header: 'Customer ID',
      size: 50,
      minSize: 200,
      filterFn: (row, colID, filterValue) => {
        return row.original.customerId
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ renderedCellValue, row }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span>{renderedCellValue}</span>
            <br />
          </Box>
        </>
      )
    },
    {
      // accessorFn: (row) => `${row.shipmentType}|${row.shipmentStatus}`,
      accessorKey: 'shipmentTypeRule',
      id: 'shipmentTypeRule',
      header: 'Shipment Type',
      size: 70,
      minSize: 200,
      filterFn: (row, colID, filterValue) => {
        return row.original.shipmentTypeRule
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ renderedCellValue, row }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {renderedCellValue}
          </Box>
        </>
      )
    }
  ];

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`
    };
  }
  // const [tableCol, setTableCol] = useState(mtransitTabColumns);

  const BASE_COLUMNS = mtransitTabColumns;

  // Then IN your component
  // minSize:200,, replace the handleFilterdTableCols with:
  const memoizedColumns = useMemo(() => {
    const columnExclusions = {
      0: [
        'carrierName',
        'proNumber',
        'bolNumber',
        'shipmentCharges',
        // 'deliveryDate',
        'actualDeliveryDate',
        'actualPickupDate',
        // 'pickupDate',
        'quoteNumber',
        'shipmentTypeRule',
        'claimStatus'
      ],
      1: [
        'carrierName',
        'proNumber',
        'bolNumber',
        'shipmentCharges',
        'deliveryDate',
        'actualDeliveryDate',
        'actualPickupDate',
        'pickupDate',
        'quoteNumber',
        'claimStatus'
      ],
      2: ['bolNumber', 'actualDeliveryDate', 'actualPickupDate', 'claimStatus'],
      3: ['pickupDate', 'actualDeliveryDate'],
      4: ['pickupDate'],
      5: [
        'carrierName',
        'proNumber',
        'bolNumber',
        'shipmentCharges',
        'deliveryDate',
        'actualDeliveryDate',
        'actualPickupDate',
        'pickupDate',
        'quoteNumber',
        'claimStatus'
      ]
    };

    const excluded = columnExclusions[value] || [];
    return BASE_COLUMNS.filter(col => !excluded.includes(col.accessorKey));
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  // Update your state and table:
  const [tableCol, setTableCol] = useState(() => memoizedColumns);

  // Add this effect to update columns when memoizedColumns changes
  useEffect(() => {
    setTableCol(memoizedColumns);
  }, [memoizedColumns]);
  const handleTabChange = (event, newValue) => {
    setValue(newValue);
    setTenderedSubFilter('all');
    setHasMore(true);
    setNoRecordMsg('Loading ...');
    setShipmentsLoader(true);
    setExpandedDetail(true);
    // handleFilterdTableCols(newValue);

    if (newValue === 2 || newValue === 3) {
      setDateFilter('This Week');
      setPagination({
        pageIndex: 1,
        pageSize: 100
      });
      setDatesRange({
        from: formatDateUTCRangeFilter(rollingWindow.startDate),
        to: formatDateUTCRangeFilter(rollingWindow.endDate)
      });
    } else {
      setDateFilter('Last 30 Days');
      setPagination({
        pageIndex: 1,
        pageSize: newValue === 4 ? 1000 : 20
      });
      setDatesRange({
        from: formatDateUTCRangeFilter(thirtyDaysAgo),
        to: formatDateUTCRangeFilter(new Date())
      });
    }

    // setViewShipmentsData([]);
  };

  // useEffect(() => {
  //   handleFilterdTableCols(value);
  // }, [value]);
  // const TableTitle = () => {
  //   console.log(value, 'valuevalue');
  //   if (value === 0) {
  //     return msavedTabColumns;
  //   } else if (value === 1) {
  //     return mbookedTabColumns;
  //   } else {
  //     return mtransitTabColumns;
  //   }
  // };

  // useEffect(() => {
  //   TableTitle();
  // }, [value]);

  const [openHoldShipmentDialog, setOpenHoldShipmentDialog] = useState(false);
  const [shipmentDialogName, setShipmentDialogName] = useState('');
  const [rowData, setrowData] = useState('');

  const handleGetClaimsData = rowData => {
    setrowData(rowData);
    GetClaimedShipmentDetails(rowData.shipmentId)
      .then(res => res.status === 200 && setClaimsData(res.data.data))
      .catch(err => console.log(err));

    setClaimDialogOpen(true);
  };

  const handleClickOpen = (dialogName, row, rowData) => {
    // rowData.stopPropagation();
    setOpenHoldShipmentDialog(true);
    // setMarkDeliverDialog(false);
    setrowData(row);
    if (dialogName === 'Hold') {
      setShipmentDialogName('Hold Shipment');
    } else if (dialogName === 'EditRow') {
      setShipmentDialogName('Update Shipment');
    } else setShipmentDialogName('Un-Book Shipment');
  };

  const handleClickCancel = row => {
    // rowData.stopPropagation();
    setOpenHoldShipmentDialog(true);
    setrowData(row.original);
    setShipmentDialogName('Cancel Shipment');
  };

  const handleClose = () => {
    setUpdateShipmentLoader(false);
    setUpdatedDeliveryDate('');
    setUpdatedPickupDate('');
    setOpenHoldShipmentDialog(false);
    setMarkDeliverDialog(false);
    setHoldShipmentRemarks('');
    setUpdatedProNmb('');
    setUpdatedPickNmb('');
    setUpdatedShipmentReason('');
    setShipmentDialogName('');
  };

  const handleSuccessTrackShip = apiRes => {
    setTrackShipmentData(apiRes);
    history.push({
      pathname: '/track-shipment',
      state: { trackShipmentData: apiRes }
    });
  };

  const handleSuccessUnBookedShipment = (ApiRes, holdShipmentRemarks, type) => {
    handleClose();
    successToast(
      `Shipment has been UnBooked with remarks, "${holdShipmentRemarks}"`
    );
    if (type === 'TL') {
      history.push('/quick-quote');
    } else {
      handleTabChange('UnBooked', 0);
    }
    setHoldShipmentRemarks('');
  };

  const handleSuccessCanceledShipment = (ApiRes, holdShipmentRemarks) => {
    handleClose();
    successToast(
      `Shipment has been Canceled with remarks, "${holdShipmentRemarks}"`
    );
    handleTabChange('Cancelled', 5);
    setHoldShipmentRemarks('');
  };

  const handleErrorUnBookedShipment = ApiError => {
    handleClose();
    ErrorToast('Something Went Wrong!');
  };

  const handleErrorCanceledShipment = ApiError => {
    handleClose();
    ErrorToast('Something Went Wrong!');
  };

  const handleTLunBookFlow = () => {
    handleUnBookShipmentRequest('TL');
  };

  const handleUnBookShipmentRequest = type => {
    // event.stopPropagation();

    const UnBookShipmentObj = {
      shipmentId: rowData?.shipmentId ? rowData?.shipmentId : 0,
      remarks: holdShipmentRemarks,
      action: 0
    };
    UnbookShipment(UnBookShipmentObj)
      .then(
        res =>
          res.status === 200 &&
          handleSuccessUnBookedShipment(res, holdShipmentRemarks, type)
      )
      .catch(err => handleErrorUnBookedShipment(err));
  };
  const updateTLShipmentRequest = () => {
    setUpdateShipmentLoader(true);
    const updateTLshipObj = {
      shipmentId: rowData?.shipmentId ?? 0,
      motorCarrierNumber: rowData?.motorCarrierNumber ?? '',
      trailerNumber: rowData?.trailerNumber ?? '',
      carrierName: rowData?.carrierName ?? '',
      pickupDate: updatedPickupDate ?? '',
      deliveryDate: updatedDeliveryDate ?? ''
    };

    UpdateTLShipment(updateTLshipObj)
      .then(res => {
        res.status === 200 && setUpdateShipmentLoader(false);
        successToast('Shipment dates updated successfully!');
        handleGetSynchDataRecords();
        handleClose();
      })
      .catch(err => {
        ErrorToast(err?.message);
      });
  };
  const handleUpdateShipment = () => {
    setUpdateShipmentLoader(true);
    const shipObj = {
      shipmentId: rowData.shipmentId ? rowData.shipmentId : 0,
      proNumber: updatedProNmb ? updatedProNmb : '',
      pickupNumber: updatedPickNmb ? updatedPickNmb : '',
      reason: updatedShipmentReason ? updatedShipmentReason : ''
    };
    UpdateShipment(shipObj)
      .then(res => {
        res.status === 200 && handleClose();
        setShipmentsLoader(false);
        setIsLoading(false);
        handleGetSynchDataRecords();
        successToast(
          `Shipment has been updated with reason, "${updatedShipmentReason}"`
        );
      })
      .catch(err => {
        handleErrorUnBookedShipment(err);
        setUpdatedProNmb('');
        setUpdatedPickNmb('');
        setUpdatedShipmentReason('');
        console.log(err, 'Update Api Error________>>>>>>>>');
      });
  };

  const handleCancelShipmentRequest = (event, selectedRowData) => {
    // event.stopPropagation();

    const UnBookShipmentObj = {
      shipmentId: rowData?.shipmentId ? rowData?.shipmentId : 0,
      remarks: holdShipmentRemarks,
      action: 0
    };
    CancelShipment(UnBookShipmentObj)
      .then(
        res =>
          res.status === 200 &&
          handleSuccessCanceledShipment(res, holdShipmentRemarks)
      )
      .catch(err => handleErrorCanceledShipment(err));
  };

  // hold- shipment
  const handleSuccessHoldShipment = (ApiRes, holdShipmentRemarks) => {
    setStatusLoader(false);
    handleClose();
    successToast(
      `Shipment has been Hold with remarks, "${holdShipmentRemarks}".`
    );
    setHoldShipmentRemarks('');
    handleGetSynchDataRecords();
  };

  const handleErrorHoldShipment = ApiError => {
    setStatusLoader(false);
    handleClose();
    ErrorToast('Something Went Wrong!');
  };

  const handleHoldShipmentRequest = (event, selectedRowData) => {
    // setStatusLoader(true);
    // event.stopPropagation();
    const HoldShipmentObj = {
      shipmentId: rowData?.shipmentId ? rowData?.shipmentId : 0,
      remarks: holdShipmentRemarks,
      action: 0
    };
    HoldShipment(HoldShipmentObj)
      .then(
        res =>
          res.status === 200 &&
          handleSuccessHoldShipment(res, holdShipmentRemarks)
      )
      .catch(err => handleErrorHoldShipment(err));
  };

  // Un-Hold shipment
  const handleSuccessUnHoldShipment = ApiRes => {
    handleGetSynchDataRecords();
    successToast('Shipment has been UnHold!');
  };

  const handleUnHoldShipmentRequest = selectedRowData => {
    // event.stopPropagation();
    const UnHoldShipmentObj = {
      shipmentId: selectedRowData?.shipmentId ? selectedRowData?.shipmentId : 0,
      remarks: '',
      action: 0
    };
    UnHoldShipment(UnHoldShipmentObj)
      .then(res => res.status === 200 && handleSuccessUnHoldShipment(res))
      .catch(err => console.log(err, 'UnHoldShipmentErr'));
  };

  // track shipment
  const handleTrackShipmentRequest = (selectedRowData, event) => {
    // event.stopPropagation();
    const obj = {
      carrierInfo: {
        id: selectedRowData?.carrierId ? selectedRowData.carrierId : 0,
        name: selectedRowData?.carrierName ? selectedRowData.carrierName : '',
        logo: ''
      },
      proNumber: selectedRowData?.proNumber,
      shipmentId: selectedRowData?.shipmentId,
      locationId: selectedRowData?.locationId,
      shipmentType: selectedRowData?.shipmentType,
      agencyId: AgencyID ? AgencyID : 0
    };

    TrackShipmentRequest(obj)
      .then(res => res.status === 200 && handleSuccessTrackShip(res.data))
      .catch(err => ErrorToast(err?.message));
  };

  // Save the column filters to storage whenever it changes
  // useEffect(() => {
  //   localStorage.setItem('columnFilters', JSON.stringify(columnFilters));
  // }, [columnFilters]);
  const claimDetailsAllowed =
    userPermissionsArr &&
    (userPermissionsArr.filter(p => p.level13).length || UserIsAdmin);

  const GetSuccessUserDetails = apiRes => {
    const shipmentOrderRaw = apiRes.data?.userSettings?.SHIPMENT_GRID_ORDER;
    const shipmentColumnsRaw = apiRes.data?.userSettings?.SHIPMENT_GRID_COLUMNS;

    const shipmentOrderArray = shipmentOrderRaw
      ? JSON.parse(shipmentOrderRaw)
      : [];
    const shipmentColumns = shipmentColumnsRaw
      ? JSON.parse(shipmentColumnsRaw)
      : {};

    if (Array.isArray(shipmentOrderArray) && shipmentOrderArray.length > 0) {
      // Filter out unwanted columns
      const filteredOrder = shipmentOrderArray.filter(
        item => item !== 'mrt-row-select' && item !== 'mrt-row-numbers'
      );

      // ENSURE mrt-row-actions is FIRST
      if (filteredOrder.includes('mrt-row-actions')) {
        const index = filteredOrder.indexOf('mrt-row-actions');
        if (index !== -1) {
          filteredOrder.splice(index, 1);
        }
        filteredOrder.unshift('mrt-row-actions');
      } else {
        filteredOrder.unshift('mrt-row-actions');
      }

      // ENSURE mrt-row-expand is SECOND
      if (filteredOrder.includes('mrt-row-expand')) {
        const index = filteredOrder.indexOf('mrt-row-expand');
        if (index !== -1) {
          filteredOrder.splice(index, 1);
        }
        filteredOrder.splice(1, 0, 'mrt-row-expand');
      } else {
        filteredOrder.splice(1, 0, 'mrt-row-expand');
      }

      setColumnOrder(filteredOrder);
    }

    if (
      shipmentColumns &&
      typeof shipmentColumns === 'object' &&
      Object.keys(shipmentColumns).length > 0
    ) {
      setColumnVisibility(shipmentColumns);
    }
  };
  const FetchCurrentUserDetails = () => {
    GetAagencyUserDetails(UserLoggedInEmail)
      .then(
        res => res.data.statusCode === 200 && GetSuccessUserDetails(res.data)
      )
      .catch(err => console.log(err));
  };

  const handleViewShipments = row => {
    setExpandedDetail(false);

    const refreshShipments = () => {
      handleGetSynchDataRecords('BOL', row.original);
      // setrowData(row.original);
    };

    return (
      <Box sx={{ maxHeight: '65vh', overflowY: 'auto' }}>
        <ViewShipment
          rowData={row.original}
          disptachOpen={'View'}
          handleTrackShipmentRequest={handleTrackShipmentRequest}
          handleGetSynchDataRecords={handleGetSynchDataRecords}
          onUpdated={refreshShipments}
          loading={isLoading}
          updateBOLDialg={updateBOLDialg}
          handleCloseBolDialog={handleCloseBolDialog}
          claimDetailsAllowed={claimDetailsAllowed}
        />
      </Box>
    );
  };
  const isFirstRender = useRef(true);

  const [columnVisibility, setColumnVisibility] = useState({});
  const [columnFilters, setColumnFilters] = useState([]);
  const [columnOrder, setColumnOrder] = useState(() => {
    // First, get the data columns from your table columns
    const dataColumns = tableCol.map(c => c.accessorKey);

    // Try to get saved order from localStorage
    const savedOrder = localStorage.getItem('shipments-column-order');
    if (savedOrder) {
      try {
        const parsed = JSON.parse(savedOrder);
        // Ensure both built-in columns are included in correct order
        if (!parsed.includes('mrt-row-actions')) {
          parsed.unshift('mrt-row-actions'); // Actions first
        }
        if (!parsed.includes('mrt-row-expand')) {
          // If expand is missing, insert it after actions (position 1)
          if (parsed[0] === 'mrt-row-actions') {
            parsed.splice(1, 0, 'mrt-row-expand');
          } else {
            parsed.unshift('mrt-row-expand');
          }
        }
        // Ensure correct order: actions first, expand second
        const actionsIndex = parsed.indexOf('mrt-row-actions');
        // Move actions to position 0
        if (actionsIndex !== 0) {
          parsed.splice(actionsIndex, 1);
          parsed.unshift('mrt-row-actions');
        }

        // Move expand to position 1
        const newExpandIndex = parsed.indexOf('mrt-row-expand');
        if (newExpandIndex !== 1) {
          parsed.splice(newExpandIndex, 1);
          parsed.splice(1, 0, 'mrt-row-expand');
        }

        return parsed;
      } catch (e) {
        console.error('Failed to parse saved column order', e);
      }
    }

    // DEFAULT ORDER - Actions first, Expand second
    return [
      'mrt-row-actions', // Three dots icon FIRST
      'mrt-row-expand', // Expand icon SECOND
      ...dataColumns
    ];
  });

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    // Ensure proper positions before saving
    const orderToSave = [...columnOrder];

    // ENSURE mrt-row-actions is FIRST
    if (orderToSave.includes('mrt-row-actions')) {
      const index = orderToSave.indexOf('mrt-row-actions');
      if (index !== -1) {
        orderToSave.splice(index, 1);
      }
      orderToSave.unshift('mrt-row-actions');
    } else {
      orderToSave.unshift('mrt-row-actions');
    }

    // ENSURE mrt-row-expand is SECOND
    if (orderToSave.includes('mrt-row-expand')) {
      const index = orderToSave.indexOf('mrt-row-expand');
      if (index !== -1) {
        orderToSave.splice(index, 1);
      }
      orderToSave.splice(1, 0, 'mrt-row-expand');
    } else {
      orderToSave.splice(1, 0, 'mrt-row-expand');
    }

    const userSettingsObj = {
      loginId: UserLoggedInEmail,
      type: 'SHIPMENT_GRID_ORDER',
      value: JSON.stringify(orderToSave)
    };
    SaveUserSettings(userSettingsObj)
      .then(res => res.status === 200 && console.log(res, 'resres'))
      .catch(err => console.log(err, 'err'));
  }, [columnOrder, UserLoggedInEmail, SaveUserSettings]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    // sessionStorage.setItem(
    //   'mrt_columnVisibility_table_1',
    //   JSON.stringify(columnVisibility)
    // );
    const userSettingsObj2 = {
      loginId: UserLoggedInEmail,
      type: 'SHIPMENT_GRID_COLUMNS',
      value: JSON.stringify(columnVisibility)
    };
    SaveUserSettings(userSettingsObj2)
      .then(res => res.status === 200 && console.log(res, 'resres'))
      .catch(err => console.log(err, 'err'));
  }, [columnVisibility, UserLoggedInEmail, SaveUserSettings]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleDateFilterModalClose = () => {
    setDateFilterModal(false);
  };

  const handleCloseAddUpdateLocation = () => {
    setAddUpdateLocationDialog(false);
    setUserLocations([]);
    setAddUpdateLocationID('');
    setAddUpdateLocationShipID('');
  };
  const handleAdminLocationChange = (event, newValue) => {
    setUserLocations(newValue);
    setAddUpdateLocationID(newValue?.id);
    // setValidationErrors({
    //   ...validationErrors,
    //   locationsError: null
    // });
  };
  const handleOpenAddUpdateLocReq = () => {
    const locatioObj = {
      shipmentId: addUpdateLocationShipID,
      locationId: addUpdateLocationID
    };
    UpdateShipmentLocation(locatioObj)
      .then(res => {
        res.status === 200 && handleCloseAddUpdateLocation();
        handleGetSynchDataRecords();
        successToast('Location Updated Successfully!');
      })
      .catch(err => {
        handleCloseAddUpdateLocation();
        ErrorToast(err?.message);
      });
  };
  const tableContainerRef = useRef(null);

  const lastScrollTop = useRef(0);

  useEffect(() => {
    const container = tableContainerRef.current;

    const handleScroll = () => {
      if (!container || isLoading || !hasMore) return;

      const { scrollTop, clientHeight, scrollHeight } = container;

      // Check if the user is scrolling down and near the bottom
      if (scrollTop > lastScrollTop.current) {
        if (
          scrollTop + clientHeight >= scrollHeight - 150 &&
          handleTotalRecords() > 20
        ) {
          setPagination(prevPagination => ({
            ...prevPagination,
            pageIndex: prevPagination.pageIndex + 1 // Increment pageIndex to load more data
          }));
        }
      }

      lastScrollTop.current = scrollTop;
    };

    // Attach the scroll event to the container
    if (container) {
      container.addEventListener('scroll', handleScroll);
    }

    // Cleanup on component unmount or re-render
    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll);
      }
    };
  }, [isLoading, hasMore]); // eslint-disable-line react-hooks/exhaustive-deps

  function RowActionMenu({ actions }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    console.log(anchorEl, actions, 'check here actions');
    if (actions.length === 1) {
      return <Box>{actions[0]}</Box>;
    }

    if (actions.length > 1) {
      return (
        <Box>
          <IconButton onClick={e => setAnchorEl(e.currentTarget)}>
            <MoreVertIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={() => setAnchorEl(null)}
          >
            {actions.map((action, i) => (
              <MenuItem key={i} onClick={() => setAnchorEl(null)} sx={{ p: 1 }}>
                {action}
              </MenuItem>
            ))}
          </Menu>
        </Box>
      );
    }

    return null; // or return <span>No Actions</span> if you prefer
  }

  const handleTotalRecords = () => {
    if (value === 0) {
      return savedShipments;
    } else if (value === 1) {
      return tenderedShipments;
    } else if (value === 2) {
      return bookedShipments;
    } else if (value === 3) {
      return inTransitShipments;
    } else if (value === 4) {
      return deliveredShipments;
    } else if (value === 5) {
      return cancelledShipments;
    }
  };

  const isMobile = useIsMobile();
  const handleCloseClaim = type => {
    if (type === 'success') {
      setClaimDialogOpen(false);
      setClaimsData(null);
      handleGetSynchDataRecords();
    } else {
      setClaimDialogOpen(false);
      setClaimsData(null);
    }
  };

  const handleCreateClaim = () => {
    setClaimDialogOpen(false);
    setClaimsData(null);
    handleGetSynchDataRecords();
  };

  return (
    <>
      <MetaTags>
        <title>Manage Shipments | TMS Shipping</title>
      </MetaTags>
      {claimDialogOpen && (
        <CreateClaimModal
          open={claimDialogOpen}
          onClose={() => handleCloseClaim('close')}
          shipment={rowData}
          onSubmit={handleCreateClaim}
          initialData={claimsData}
          isEditMode={!!claimsData?.id}
        />
      )}

      <Dialog
        sx={{ minWidth: 400 }}
        open={DateFilterModal}
        onClose={handleDateFilterModalClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>Date Filter</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            <TextField
              // value={holdShipmentRemarks}
              onChange={handleDateFilterModalClose}
              variant='standard'
              type='date'
              // fullWidth
              sx={{ width: '13vw' }}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={handleDateFilterModalClose}>
            Cancel
          </Button>
          <Button
            variant='contained'

            // autoFocus
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        PaperProps={
          isMobile
            ? {}
            : {
                style: {
                  minWidth: '20vw',
                  height: 'auto',
                  maxHeight: '70vh'
                }
              }
        }
        sx={{ minWidth: 400 }}
        open={openHoldShipmentDialog}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          {markDeliverDialog
            ? 'Are you sure to mark as Deilvered ?'
            : shipmentDialogName}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id='alert-dialog-description'
            style={{ height: openDeliverDialog ? 300 : 'auto' }}
          >
            {shipmentDialogName === 'Update Shipment' ? (
              <Box sx={{ gap: 4, display: 'flex', flexDirection: 'column' }}>
                {rowData.shipmentType !== 'TL' && (
                  <>
                    <TextField
                      value={updatedProNmb}
                      onChange={e => setUpdatedProNmb(e.target.value)}
                      variant='standard'
                      label='New PRO# '
                      placeholder='Enter the new PRO# to be assigned. '
                      type='text'
                      required
                      sx={{ width: '30vw' }}
                      helperText={`Current PRO#: ${rowData.proNumber}`}
                    />
                    <TextField
                      value={updatedPickNmb}
                      onChange={e => setUpdatedPickNmb(e.target.value)}
                      variant='standard'
                      label='New Pickup# '
                      placeholder='Enter the new Pickup# to be assigned. '
                      type='text'
                      required
                      sx={{ width: '30vw' }}
                      helperText={`Current Pickup#: ${rowData.pickupNumber}`}
                    />
                  </>
                )}

                {/* Conditionally show date inputs for TL shipments */}
                {rowData.shipmentType === 'TL' && (
                  <>
                    <TextField
                      label='New Requested Pickup Date'
                      type='date'
                      sx={{ width: '30vw' }}
                      variant='standard'
                      value={updatedPickupDate}
                      onChange={e => {
                        const newPickupDate = e.target.value;
                        setUpdatedPickupDate(newPickupDate);

                        // If delivery date exists and is earlier than new pickup date, reset it
                        if (
                          updatedDeliveryDate &&
                          newPickupDate &&
                          newPickupDate > updatedDeliveryDate
                        ) {
                          setUpdatedDeliveryDate('');
                        }
                      }}
                      InputLabelProps={{
                        shrink: true
                      }}
                      helperText={`Current PickupDate: ${rowData.pickupDate}`}
                      fullWidth
                    />
                    <TextField
                      label='New Delivery Date'
                      type='date'
                      variant='standard'
                      sx={{ width: '30vw' }}
                      value={updatedDeliveryDate}
                      onChange={e => {
                        const newDeliveryDate = e.target.value;
                        setUpdatedDeliveryDate(newDeliveryDate);
                      }}
                      InputLabelProps={{
                        shrink: true
                      }}
                      error={
                        updatedPickupDate &&
                        updatedDeliveryDate &&
                        updatedDeliveryDate < updatedPickupDate
                      }
                      helperText={
                        updatedPickupDate &&
                        updatedDeliveryDate &&
                        updatedDeliveryDate < updatedPickupDate
                          ? 'Delivery date cannot be earlier than pickup date'
                          : `Current DeliveryDate: ${rowData.deliveryDate}`
                      }
                      fullWidth
                    />
                  </>
                )}

                <TextField
                  label='Reason for Change'
                  sx={{ width: '30vw' }}
                  value={updatedShipmentReason}
                  onChange={e => setUpdatedShipmentReason(e.target.value)}
                  multiline
                  maxRows={4}
                  variant='standard'
                  fullWidth
                />
              </Box>
            ) : !markDeliverDialog ? (
              <TextField
                value={holdShipmentRemarks}
                onChange={e => setHoldShipmentRemarks(e.target.value)}
                variant='standard'
                label='Remarks'
                multiline
                maxRows={4}
                type='text'
                sx={{ width: 'auto', minWidth: '25vw' }}
              />
            ) : (
              <Box
                sx={{
                  display: 'flex',
                  gap: 1
                  // alignItems: 'center',
                  // justifyContent: 'center'
                }}
              >
                <DateRangeFilter
                  inputRef={pickupDatepickerRef}
                  handleIconClick={handlePickupDateIconClick}
                  styleProp={'shipmentsTable'}
                  selected={markAsDeliverDate}
                  onChange={date => setMarkAsDeliverDate(date.date)}
                  placeholderText='Select Delivery Date'
                  markingDone={true}
                  setOpenDeliverDialog={setOpenDeliverDialog}
                  style={{ width: 10 }}
                />
                <TextField
                  label='Delivery Time'
                  type='time'
                  variant='standard'
                  value={markAsDeliverTime}
                  onChange={e => setMarkAsDeliverTime(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ step: 300 }}
                  sx={{ minWidth: 70, mt: -2 }}
                />
              </Box>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button size='small' variant='outlined' onClick={handleClose}>
            Cancel
          </Button>
          <Button
            sx={{ minWidth: 120 }}
            size='small'
            color='warning'
            variant='contained'
            disabled={
              updateShipmentLoader ||
              (rowData.shipmentType === 'TL' &&
                updatedPickupDate &&
                updatedDeliveryDate &&
                updatedDeliveryDate < updatedPickupDate)
            }
            onClick={
              rowData?.shipmentType === 'TL'
                ? updateTLShipmentRequest
                : markDeliverDialog
                  ? markAsDeliverRequest
                  : shipmentDialogName === 'Hold Shipment'
                    ? handleHoldShipmentRequest
                    : shipmentDialogName === 'Cancel Shipment'
                      ? handleCancelShipmentRequest
                      : shipmentDialogName === 'Update Shipment'
                        ? handleUpdateShipment
                        : handleUnBookShipmentRequest
            }
            // autoFocus
          >
            {markDeliverDialog ? (
              'Confirm'
            ) : updateShipmentLoader ? (
              <CircularProgress sx={{ color: 'white' }} size={22} />
            ) : (
              shipmentDialogName
            )}
          </Button>
          {rowData?.shipmentType === 'TL' &&
            value !== 0 &&
            shipmentDialogName === 'Un-Book Shipment' && (
              <Button
                size='small'
                variant='contained'
                color='success'
                onClick={handleTLunBookFlow}
              >
                UnBook & Re-Schedule
              </Button>
            )}
        </DialogActions>
      </Dialog>
      <Dialog
        sx={{ minWidth: 700 }}
        open={addUpdateLocationDialog}
        onClose={handleCloseAddUpdateLocation}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>Update Location</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            {agencyLocationsLoader ? (
              <Box
                sx={{
                  width: '27vw',
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <CircularProgress size={25} />
              </Box>
            ) : (
              <Autocomplete
                sx={{ width: '27vw' }}
                size='small'
                value={agencyLocations.find(
                  opt => opt.name === clickedRowLocation
                )}
                onChange={(event, newValue) =>
                  handleAdminLocationChange(event, newValue)
                }
                renderOption={(PreviousProps, option, { selected }) => (
                  <li {...PreviousProps}>
                    {`${option.name}: ${option.city}  ${
                      option.state ? option.state : option.stateOrProvinceCode
                    }  ${option.postalCode}`}
                  </li>
                )}
                getOptionLabel={
                  option =>
                    // option.city ?
                    `${option.city}  ${
                      option.state ? option.state : option.stateOrProvinceCode
                    }  ${option.postalCode}`
                  // : 'Select location'
                }
                options={agencyLocations}
                renderInput={params => (
                  <TextField
                    required
                    label='Locations'
                    variant='standard'
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                      style: { fontSize: 13 }
                    }}
                    // error={Boolean(validationErrors['locationsError'])}
                    // helperText={validationErrors['locationsError']}
                  />
                )}
              />
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            size='small'
            variant='outlined'
            onClick={handleCloseAddUpdateLocation}
          >
            Cancel
          </Button>
          <Button
            onClick={handleOpenAddUpdateLocReq}
            // disabled={addUpdateLocationID ? false : true}
            size='small'
            variant='contained'
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
      {!openHoldShipmentDialog && (
        <div ref={componentRef} className='shipments'>
          <ToastContainer
            style={{ width: 'auto' }}
            position='top-center'
            autoClose={6800}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <link
            rel='stylesheet'
            href='https://fonts.googleapis.com/icon?family=Material+Icons'
          />
          <div>
            <MaterialReactTable
              enableRowNumbers
              enableRowActions
              onExpandedChange={updater => {
                setExpanded(prevExpanded => {
                  // Get the next state from the updater
                  const nextExpanded =
                    typeof updater === 'function'
                      ? updater(prevExpanded)
                      : updater;

                  // Find the ID of the row that was just clicked/expanded
                  const newlyExpandedRowId = Object.keys(nextExpanded).find(
                    key => nextExpanded[key] && !prevExpanded[key]
                  );

                  // If a new row was expanded, return an object containing ONLY that row ID.
                  // This automatically closes any previously opened row.
                  if (newlyExpandedRowId) {
                    return { [newlyExpandedRowId]: true };
                  }

                  // If the user was closing a row, return the empty object
                  return nextExpanded;
                });
              }}
              displayColumnDefOptions={{
                'mrt-row-actions': {
                  header: 'Actions',
                  size: value === 4 ? 150 : 100,
                  minSize: value === 4 ? 150 : 100
                },
                // ADD THIS BLOCK BELOW:
                'mrt-row-expand': {
                  header: '', // This removes the "Expand" text
                  size: 0 // Adjust width of the expand column if needed
                }
              }}
              rowNumberMode='original'
              muiTableHeadCellFilterTextFieldProps={() => ({
                placeholder: '' // Hide the placeholder,
              })}
              muiTableProps={{
                sx: {
                  tableLayout: 'fixed'
                }
              }}
              muiTableHeadCellProps={{
                sx: {
                  whiteSpace: 'nowrap',
                  fontWeight: 600
                }
              }}
              muiTableBodyCellProps={{
                sx: {
                  whiteSpace: 'nowrap'
                }
              }}
              muiTableContainerProps={{
                ref: tableContainerRef,
                sx: {
                  maxHeight: '70vh',
                  minHeight: '70vh',
                  overflow:
                    Object.keys(expanded).length > 0 ? 'hidden' : 'auto',
                  display: 'block',
                  '&::-webkit-scrollbar': {
                    height: '10px',
                    width: '8px'
                  },
                  '&::-webkit-scrollbar-track': {
                    backgroundColor: '#f1f1f1',
                    borderRadius: '10px'
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#3484db',
                    borderRadius: '10px',
                    border: '2px solid #3484db',
                    '&:hover': {
                      backgroundColor: '#5F82E0'
                    }
                  }
                }
              }}
              enableExpandAll={false}
              enableRowVirtualization={true}
              rowVirtualizerOptions={{
                overscan: 30,
                estimateSize: () => 300
              }}
              muiTableHeadProps={{
                style: {
                  position: 'sticky',
                  top: 0,
                  zIndex: 1,
                  backgroundColor: '#fff'
                }
              }}
              onGlobalFilterChange={setGlobalFilter}
              renderRowActions={({ row }) => {
                const actions = [];
                var shipStatus = row.original.shipmentStatus.toLowerCase();
                const bookShipAllowed =
                  userPermissionsArr &&
                  (userPermissionsArr.filter(p => p.level3).length ||
                    UserIsAdmin);

                const createClaimAllowed =
                  userPermissionsArr &&
                  (userPermissionsArr.filter(p => p.level11).length ||
                    UserIsAdmin);

                const updateClaimAllowed =
                  userPermissionsArr &&
                  (userPermissionsArr.filter(p => p.level12).length ||
                    UserIsAdmin);

                const cancelShipAllowed =
                  userPermissionsArr &&
                  (userPermissionsArr.filter(p => p.level4).length ||
                    UserIsAdmin);

                const viewTenderShipAllowed =
                  userPermissionsArr &&
                  (userPermissionsArr.filter(p => p.level5).length ||
                    UserIsAdmin);

                const pickupShipAllowed =
                  userPermissionsArr &&
                  (userPermissionsArr.filter(p => p.level6).length ||
                    UserIsAdmin);

                const unBookShipAllowed =
                  userPermissionsArr &&
                  (userPermissionsArr.filter(p => p.level7).length ||
                    UserIsAdmin);

                const holdUnholdShipAllowed =
                  userPermissionsArr &&
                  (userPermissionsArr.filter(p => p.level8).length ||
                    UserIsAdmin);

                const markAsDeliverShipAllowed =
                  userPermissionsArr &&
                  (userPermissionsArr.filter(p => p.level10).length ||
                    UserIsAdmin);

                const showView =
                  (shipStatus === 'saved' ||
                    shipStatus === 'tendered' ||
                    shipStatus === 'booked' ||
                    shipStatus === 'approvedforbooking') &&
                  row.original.shipmentType === 'TL';

                const showPickup =
                  ((shipStatus === 'saved' &&
                    row.original.shipmentType === 'LTL') ||
                    shipStatus === 'tendered') &&
                  row.original.quoteId === 0 &&
                  row.index !== checkLocIndex;

                const showCancel =
                  (shipStatus === 'saved' || shipStatus === 'tendered') &&
                  row.original.quoteId === 0 &&
                  row.index !== checkLocIndex;

                const showPickedUp = shipStatus === 'booked';

                const showHold =
                  shipStatus === 'booked' &&
                  (row.original.shipmentStatus.toLowerCase() === 'hold' ||
                    row.original.shipmentStatus.toLowerCase() !== 'hold');

                const showUnBook = shipStatus === 'booked';

                const showMarkAsDelivered =
                  shipStatus === 'intransit' &&
                  row.original.shipmentType === 'TL';

                const showEdit =
                  (shipStatus === 'booked' || shipStatus === 'intransit') &&
                  row.original.shipmentType !== 'TL';

                const updateShipAllowed =
                  userPermissionsArr &&
                  (userPermissionsArr.filter(p => p.level3).length ||
                    UserIsAdmin);

                // Actions
                if (showView && viewTenderShipAllowed) {
                  actions.push(
                    <Button
                      key='View'
                      size='small'
                      color='primary'
                      startIcon={<VisibilityIcon fontSize='small' />}
                      onClick={() =>
                        handlePickupOpen(row.original, row, 'TenderTL')
                      }
                    >
                      View
                    </Button>
                  );
                }

                if (showPickup && bookShipAllowed) {
                  const label =
                    row.original.freightTerms.toLowerCase() === 'c' ||
                    row.original.freightTerms.toLowerCase() === 'n'
                      ? 'Pickup'
                      : 'Book';

                  actions.push(
                    <Button
                      key={label}
                      size='small'
                      color='primary'
                      startIcon={<LaunchTwoToneIcon fontSize='small' />}
                      onClick={() =>
                        row.original.freightTerms.toLowerCase() === 'c' ||
                        row.original.freightTerms.toLowerCase() === 'n'
                          ? handlePickupOpen(row.original, row, 'Dispatch')
                          : handlePickupOpen(row.original, row, 'Get Quote')
                      }
                    >
                      {label}
                    </Button>
                  );
                }

                if (showCancel && cancelShipAllowed) {
                  actions.push(
                    <Button
                      key='Cancel'
                      size='small'
                      color='primary'
                      startIcon={
                        <DisabledByDefaultTwoToneIcon fontSize='small' />
                      }
                      onClick={() => handleClickCancel(row)}
                    >
                      Cancel
                    </Button>
                  );
                }

                if (showPickedUp && pickupShipAllowed) {
                  actions.push(
                    <Button
                      key='Dispatched'
                      size='small'
                      color='primary'
                      startIcon={<LaunchTwoToneIcon fontSize='small' />}
                      onClick={() =>
                        handlePickupOpen(row.original, row, 'Dispatch')
                      }
                    >
                      Dispatched
                    </Button>
                  );
                }

                if (showHold && holdUnholdShipAllowed) {
                  const label =
                    row.original.shipmentStatus.toLowerCase() === 'hold'
                      ? 'UnHold'
                      : 'Hold';

                  actions.push(
                    <Button
                      key={label}
                      size='small'
                      color='primary'
                      startIcon={<PanToolTwoToneIcon fontSize='small' />}
                      onClick={() => {
                        row.original.shipmentStatus.toLowerCase() === 'hold'
                          ? handleUnHoldShipmentRequest(row.original)
                          : handleClickOpen('Hold', row.original);
                      }}
                    >
                      {label}
                    </Button>
                  );
                }

                if (showUnBook && unBookShipAllowed) {
                  actions.push(
                    <Button
                      key='UnBook'
                      size='small'
                      color='primary'
                      startIcon={
                        <DisabledByDefaultTwoToneIcon fontSize='small' />
                      }
                      onClick={() => handleClickOpen('UnBook', row.original)}
                    >
                      UnBook
                    </Button>
                  );
                }

                if (showEdit && updateShipAllowed) {
                  actions.push(
                    <Button
                      key='Edit'
                      size='small'
                      color='primary'
                      startIcon={<EditIcon fontSize='small' />}
                      onClick={() => handleClickOpen('EditRow', row.original)}
                    >
                      Edit
                    </Button>
                  );
                }

                if (showMarkAsDelivered && markAsDeliverShipAllowed) {
                  actions.push(
                    <Button
                      key='MarkDelivered'
                      size='small'
                      color='primary'
                      startIcon={<TaskAltIcon fontSize='small' />}
                      onClick={() =>
                        handleMarkDeliver(row.original, 'MarkDeliver')
                      }
                    >
                      Mark as Delivered
                    </Button>
                  );
                }

                const showClaimButton =
                  (shipStatus === 'intransit' || shipStatus === 'delivered') &&
                  row.original.shipmentType !== 'TL';

                if (showClaimButton) {
                  const hasExistingClaim = !!row.original?.claimStatus;
                  const canCreate = createClaimAllowed && !hasExistingClaim;
                  const canUpdate = updateClaimAllowed && hasExistingClaim;

                  if (canCreate || canUpdate) {
                    actions.push(
                      <Button
                        key='claim-action'
                        variant='text'
                        size='small'
                        startIcon={<Gavel />}
                        color='primary'
                        onClick={() => handleGetClaimsData(row.original)}
                      >
                        {canUpdate ? 'Update Claim' : 'Create Claim'}
                      </Button>
                    );
                  }
                }

                return <RowActionMenu actions={actions} />;
              }}
              manualPagination
              // pageCount={200}
              rowCount={totalShipmentsCount}
              resetColumnOrder
              // autoResetAll
              autoResetExpanded={true}
              onColumnFiltersChange={setColumnFilters}
              onColumnVisibilityChange={setColumnVisibility}
              onColumnOrderChange={newOrder => {
                // Filter out unwanted system columns
                const filteredOrder = newOrder.filter(
                  id => id !== 'mrt-row-numbers' && id !== 'mrt-row-select'
                );

                // ENSURE mrt-row-actions is ALWAYS the FIRST column
                if (filteredOrder.includes('mrt-row-actions')) {
                  // Remove it from its current position
                  const index = filteredOrder.indexOf('mrt-row-actions');
                  if (index !== -1) {
                    filteredOrder.splice(index, 1);
                  }
                  // Add it at the beginning (position 0)
                  filteredOrder.unshift('mrt-row-actions');
                } else {
                  filteredOrder.unshift('mrt-row-actions');
                }

                // ENSURE mrt-row-expand is ALWAYS the SECOND column
                if (filteredOrder.includes('mrt-row-expand')) {
                  // Remove it from its current position
                  const index = filteredOrder.indexOf('mrt-row-expand');
                  if (index !== -1) {
                    filteredOrder.splice(index, 1);
                  }
                  // Add it at position 1 (after actions)
                  filteredOrder.splice(1, 0, 'mrt-row-expand');
                } else {
                  filteredOrder.splice(1, 0, 'mrt-row-expand');
                }

                setColumnOrder(filteredOrder);

                // Save to localStorage
                localStorage.setItem(
                  'shipments-column-order',
                  JSON.stringify(filteredOrder)
                );
              }}
              state={{
                isLoading: shipmentsLoader,
                columnVisibility,
                globalFilter,
                columnOrder,
                expanded,
                pagination,
                // draggingColumn
                columnFilters,
                // density,
                // globalFilter,
                showColumnFilters: true
                // showGlobalFilter,
                // sorting
              }}
              // rowCount={viewShipmentsData.length + 1}
              localization={{
                noRecordsToDisplay: noRecordMsg
              }}
              enablePagination={false}
              initialState={{
                // showColumnFilters: true,
                density: 'compact'
              }}
              getRowId={originalRow => originalRow.id}
              columns={memoizedColumns}
              data={viewShipmentsData}
              enableColumnOrdering
              enableColumnActions
              enableGrouping={expandedDetail}
              renderBottomToolbarCustomActions={() => (
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <div>
                    {columnFilters.length > 0 && (
                      <Typography>
                        Filtered records: <b>{filteredRowCount}</b>
                      </Typography>
                    )}
                  </div>
                  {isLoading ? (
                    <Box sx={{ width: '20%' }}>
                      <LinearProgress variant='query' />
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}
                    >
                      <Select
                        sx={{ minWidth: 20, maxHeight: 30, mr: 1 }}
                        variant='outlined'
                        value={pagination.pageSize}
                        onChange={handleRecordsChange}
                        label='Records'
                      >
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={40}>40</MenuItem>
                        <MenuItem value={60}>60</MenuItem>
                        <MenuItem value={80}>80</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                        <MenuItem value={1000}>1000</MenuItem>

                        {/* <MenuItem value={handleTotalRecords()}>All</MenuItem> */}
                      </Select>
                      <Typography sx={{ marginRight: 2 }}>
                        Fetched <b>{viewShipmentsData.length}</b> out of{' '}
                        <b>
                          {searchQuery !== ''
                            ? totalShipmentsCount
                            : handleTotalRecords()}
                        </b>{' '}
                        total records.
                      </Typography>
                    </Box>
                  )}
                </div>
              )}
              renderDetailPanel={({ row }) =>
                userPermissionsArr &&
                (userPermissionsArr.filter(permissions => permissions.level2)
                  .length ||
                  UserIsAdmin)
                  ? handleViewShipments(row)
                  : null
              }
              positionToolbarAlertBanner='bottom'
              renderToolbarInternalActions={({ table }) => (
                <div>
                  {setFilteredRowCount(table.getFilteredRowModel().rows.length)}
                  {isMobile && (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        bgcolor: 'background.paper'
                      }}
                    >
                      <Tabs
                        value={value}
                        onChange={handleTabChange}
                        variant='scrollable' // Makes the tabs scrollable
                        scrollButtons='auto' // Automatically shows scroll buttons when necessary
                        aria-label='scrollable tabs example'
                        allowScrollButtonsMobile
                        sx={{
                          ml: -2,
                          overflowX: 'auto', // Force horizontal scroll
                          whiteSpace: 'nowrap', // Prevent wrapping
                          '& .MuiTabs-scrollButtons': {
                            '&.Mui-disabled': { opacity: 0.3 }
                          }
                        }}
                      >
                        <Tab
                          sx={{
                            // minWidth: 'fit-content',
                            fontWeight: 600,
                            fontSize: 14,
                            width: '25%'
                          }}
                          label=<div className='Tabs_Badge_Title'>
                            <Badge
                              max={savedShipments}
                              color='primary'
                              sx={
                                savedShipments.toString().length > 3
                                  ? { padding: '0 15 0 0', marginLeft: 2 }
                                  : { padding: '0 20 0 0' }
                              }
                              badgeContent={savedShipments}
                            />
                            <div>Saved</div>
                          </div>
                          {...a11yProps(0)}
                        />
                        <Tab
                          sx={{
                            fontWeight: 600,
                            fontSize: 14,
                            width: '25%'
                          }}
                          label=<div className='Tabs_Badge_Title'>
                            <Badge
                              max={tenderedShipments}
                              color='error'
                              sx={
                                tenderedShipments.toString().length > 3
                                  ? { padding: '0 15 0 0', marginLeft: 2 }
                                  : { padding: '0 20 0 0' }
                              }
                              badgeContent={tenderedShipments}
                            />
                            <div>Tendered</div>
                          </div>
                          {...a11yProps(1)}
                        />
                        <Tab
                          sx={{
                            fontWeight: 600,
                            fontSize: 14,
                            width: '25%'
                          }}
                          label=<div className='Tabs_Badge_Title'>
                            <div style={{ backgroundColor: '#f3e5f5' }}>
                              <Badge
                                max={bookedShipments}
                                sx={
                                  bookedShipments.toString().length > 3
                                    ? { padding: '0 15 0 0', marginLeft: 2 }
                                    : { padding: '0 20 0 0' }
                                }
                                badgeContent={bookedShipments}
                                variant='standard'
                                color='secondary'
                              />
                            </div>
                            <div>Booked</div>
                          </div>
                          {...a11yProps(2)}
                        />
                        <Tab
                          sx={{
                            fontWeight: 600,
                            fontSize: 14,
                            width: '25%'
                          }}
                          label=<div className='Tabs_Badge_Title'>
                            <div style={{ backgroundColor: '#f3e5f5' }}>
                              <Badge
                                max={inTransitShipments}
                                sx={
                                  inTransitShipments.toString().length > 3
                                    ? { padding: '0 15 0 0', marginLeft: 2 }
                                    : { padding: '0 20 0 0' }
                                }
                                badgeContent={inTransitShipments}
                                variant='standard'
                                color='warning'
                              />
                            </div>
                            <div>In-Transit</div>
                          </div>
                          {...a11yProps(3)}
                        />
                        <Tab
                          sx={{
                            fontWeight: 600,
                            fontSize: 14,
                            width: '25%'
                          }}
                          label=<div className='Tabs_Badge_Title'>
                            <div style={{ backgroundColor: '#f3e5f5' }}>
                              <Badge
                                max={deliveredShipments}
                                sx={
                                  deliveredShipments.toString().length > 3
                                    ? { padding: '0 15 0 0', marginLeft: 2 }
                                    : { padding: '0 20 0 0' }
                                }
                                badgeContent={deliveredShipments}
                                variant='standard'
                                color='success'
                              />
                            </div>
                            <div>Delivered</div>
                          </div>
                          {...a11yProps(4)}
                        />
                      </Tabs>
                    </Box>
                  )}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'end',
                      alignItems: 'center'
                    }}
                  >
                    {/* <MRT_ToggleGlobalFilterButton
                      table={table}
                      title='Search'
                    /> */}

                    {fetchTrackingLoaderState && (
                      <Chip
                        sx={{
                          whiteSpace: 'nowrap',
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1
                        }}
                        // size='small'
                        variant='outlined'
                        label={
                          <Box display='flex' alignItems='center' gap={1}>
                            Fetching Latest Tracking Status ...
                            <CircularProgress
                              sx={{ color: 'rgb(0 0 0 / 54%)' }}
                              size={18}
                              thickness={6}
                            />
                          </Box>
                        }
                      />
                    )}
                    {(value === 2 || value === 3 || value === 4) &&
                      !fetchTrackingLoaderState && (
                        <Tooltip arrow title='Fetch Latest Tracking Status'>
                          <IconButton
                            onClick={() => handleFetchLatestTrackShipments()}
                          >
                            {fetchTrackingLoaderState ? (
                              <CircularProgress
                                sx={{
                                  color: 'rgb(0 0 0 / 54%)'
                                }}
                                size={22}
                                thickness={4}
                              />
                            ) : (
                              <CloudSyncRoundedIcon />
                            )}
                          </IconButton>
                        </Tooltip>
                      )}
                    <Tooltip arrow title='Print'>
                      <IconButton
                        // sx={{ m: 0.5 }}
                        onClick={() => {
                          handlePrint();
                        }}
                      >
                        <LocalPrintshopOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                    {/* <Tooltip arrow title='Import'>
                      <IconButton
                        sx={{ m: 0.5 }}
                        onClick={() => fileInputRef?.current?.click()}
                      >
                        <input
                          ref={fileInputRef}
                          type='file'
                          style={{ display: 'none' }}
                          onChange={handleFileChange}
                        ></input>
                        <svg
                          style={{ transform: 'rotate(180deg)' }}
                          width='17'
                          height='21'
                          viewBox='0 0 17 21'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M10.625 0.828125H2.625C1.525 0.828125 0.635 1.72812 0.635 2.82812L0.625 18.8281C0.625 19.9281 1.515 20.8281 2.615 20.8281H14.625C15.725 20.8281 16.625 19.9281 16.625 18.8281V6.82812L10.625 0.828125ZM14.625 18.8281H2.625V2.82812H9.625V7.82812H14.625V18.8281ZM4.625 13.8381L6.035 15.2481L7.625 13.6681V17.8281H9.625V13.6681L11.215 15.2581L12.625 13.8381L8.635 9.82812L4.625 13.8381Z'
                            fill='currentColor'
                          />
                        </svg>
                      </IconButton>
                    </Tooltip> */}
                    {/* Export funtion */}
                    {/* <Tooltip
                      sx={{ m: 0.5 }}
                      arrow
                      title={
                        !table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected()
                          ? 'Export All Rows'
                          : 'Export Selected Rows'
                      }
                    >
                      <IconButton
                        // onClick={handleExportData}
                        onClick={() =>
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                            ? handleExportData(table.getCoreRowModel().rows)
                            : handleExportRows(table.getSelectedRowModel().rows)
                        }
                        // sx={{ marginRight: -1.5 }}
                      >
                        <svg
                          width='17'
                          height='21'
                          viewBox='0 0 17 21'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M10.625 0.828125H2.625C1.525 0.828125 0.635 1.72812 0.635 2.82812L0.625 18.8281C0.625 19.9281 1.515 20.8281 2.615 20.8281H14.625C15.725 20.8281 16.625 19.9281 16.625 18.8281V6.82812L10.625 0.828125ZM14.625 18.8281H2.625V2.82812H9.625V7.82812H14.625V18.8281ZM4.625 13.8381L6.035 15.2481L7.625 13.6681V17.8281H9.625V13.6681L11.215 15.2581L12.625 13.8381L8.635 9.82812L4.625 13.8381Z'
                            fill='currentColor'
                          />
                        </svg>
                      </IconButton>
                    </Tooltip> */}

                    {/* eslint-disable-next-line react/jsx-pascal-case */}
                    <MRT_ToggleDensePaddingButton
                      table={table}
                      title='Spacing'
                    />
                    {/* eslint-disable-next-line react/jsx-pascal-case */}
                    <MRT_ShowHideColumnsButton
                      table={table}
                      title='Show/Hide Columns'
                    />
                    {/* eslint-disable-next-line react/jsx-pascal-case */}
                    <MRT_FullScreenToggleButton
                      table={table}
                      title='Fullscreen'
                    />

                    <Tooltip title='Clear All Filters' arrow>
                      <IconButton
                        onClick={() => {
                          table.resetColumnFilters(true);
                          table.setShowColumnFilters(false);
                        }}
                      >
                        <FilterAltOffIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                  {/* <Tooltip title='Apply current grid settings' arrow>
                      <IconButton onClick={handleGridApplySettings}>
                        <GridOnIcon />
                      </IconButton>
                    </Tooltip> */}
                </div>
              )}
              renderTopToolbarCustomActions={({ table }) => {
                return (
                  !isMobile &&
                  !searchQuery && (
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        bgcolor: 'background.paper'
                      }}
                    >
                      <Tabs
                        value={value}
                        onChange={handleTabChange}
                        variant='scrollable' // Makes the tabs scrollable
                        scrollButtons='auto' // Automatically shows scroll buttons when necessary
                        aria-label='scrollable tabs example'
                        allowScrollButtonsMobile
                        sx={
                          isMobile
                            ? {
                                overflowX: 'auto', // Force horizontal scroll
                                whiteSpace: 'nowrap', // Prevent wrapping
                                '& .MuiTabs-scrollButtons': {
                                  '&.Mui-disabled': { opacity: 0.3 }
                                }
                              }
                            : { mb: 1 }
                        }
                      >
                        <Tab
                          sx={
                            isMobile
                              ? {
                                  // minWidth: 'fit-content',
                                  fontWeight: 600,
                                  fontSize: 14,
                                  width: '25%'
                                }
                              : {
                                  // minWidth: 'fit-content',
                                  fontWeight: 600,
                                  fontSize: 14,
                                  width: 150
                                }
                          }
                          label=<div className='Tabs_Badge_Title'>
                            <Badge
                              max={savedShipments}
                              color='primary'
                              sx={
                                savedShipments.toString().length > 3
                                  ? { padding: '0 15 0 0', marginLeft: 2 }
                                  : { padding: '0 20 0 0' }
                              }
                              badgeContent={savedShipments}
                            />
                            <div>Saved</div>
                          </div>
                          {...a11yProps(0)}
                        />
                        <Tab
                          sx={
                            isMobile
                              ? {
                                  // minWidth: 'fit-content',
                                  fontWeight: 600,
                                  fontSize: 14,
                                  width: '25%'
                                }
                              : {
                                  // minWidth: 'fit-content',
                                  fontWeight: 600,
                                  fontSize: 14,
                                  width: 150
                                }
                          }
                          label=<div className='Tabs_Badge_Title'>
                            <Badge
                              max={tenderedShipments}
                              color='error'
                              sx={
                                tenderedShipments.toString().length > 3
                                  ? { padding: '0 15 0 0', marginLeft: 2 }
                                  : { padding: '0 20 0 0' }
                              }
                              badgeContent={tenderedShipments}
                            />
                            <div>Tendered</div>
                          </div>
                          {...a11yProps(1)}
                        />
                        <Tab
                          sx={
                            isMobile
                              ? {
                                  // minWidth: 'fit-content',
                                  fontWeight: 600,
                                  fontSize: 14,
                                  width: '25%'
                                }
                              : {
                                  // minWidth: 'fit-content',
                                  fontWeight: 600,
                                  fontSize: 14,
                                  width: 150
                                }
                          }
                          label=<div className='Tabs_Badge_Title'>
                            <div style={{ backgroundColor: '#f3e5f5' }}>
                              <Badge
                                max={bookedShipments}
                                sx={
                                  bookedShipments.toString().length > 3
                                    ? { padding: '0 15 0 0', marginLeft: 2 }
                                    : { padding: '0 20 0 0' }
                                }
                                badgeContent={bookedShipments}
                                variant='standard'
                                color='secondary'
                              />
                            </div>
                            <div>Booked</div>
                          </div>
                          {...a11yProps(2)}
                        />
                        <Tab
                          sx={
                            isMobile
                              ? {
                                  // minWidth: 'fit-content',
                                  fontWeight: 600,
                                  fontSize: 14,
                                  width: '25%'
                                }
                              : {
                                  // minWidth: 'fit-content',
                                  fontWeight: 600,
                                  fontSize: 14,
                                  width: 150
                                }
                          }
                          label=<div className='Tabs_Badge_Title'>
                            <div style={{ backgroundColor: '#f3e5f5' }}>
                              <Badge
                                max={inTransitShipments}
                                sx={
                                  inTransitShipments.toString().length > 3
                                    ? { padding: '0 15 0 0', marginLeft: 2 }
                                    : { padding: '0 20 0 0' }
                                }
                                badgeContent={inTransitShipments}
                                variant='standard'
                                color='warning'
                              />
                            </div>
                            <div>In-Transit</div>
                          </div>
                          {...a11yProps(3)}
                        />
                        <Tab
                          sx={
                            isMobile
                              ? {
                                  // minWidth: 'fit-content',
                                  fontWeight: 600,
                                  fontSize: 14,
                                  width: '25%'
                                }
                              : {
                                  // minWidth: 'fit-content',
                                  fontWeight: 600,
                                  fontSize: 14,
                                  width: 150
                                }
                          }
                          label=<div className='Tabs_Badge_Title'>
                            <div style={{ backgroundColor: '#f3e5f5' }}>
                              <Badge
                                max={deliveredShipments}
                                sx={
                                  deliveredShipments.toString().length > 3
                                    ? { padding: '0 15 0 0', marginLeft: 2 }
                                    : { padding: '0 20 0 0' }
                                }
                                badgeContent={deliveredShipments}
                                variant='standard'
                                color='success'
                              />
                            </div>
                            <div>Delivered</div>
                          </div>
                          {...a11yProps(4)}
                        />

                        <Tab
                          sx={
                            isMobile
                              ? {
                                  // minWidth: 'fit-content',
                                  fontWeight: 600,
                                  fontSize: 14,
                                  width: '25%'
                                }
                              : {
                                  // minWidth: 'fit-content',
                                  fontWeight: 600,
                                  fontSize: 14,
                                  width: 150
                                }
                          }
                          label=<div className='Tabs_Badge_Title'>
                            <div style={{ backgroundColor: '#f3e5f5' }}>
                              <Badge
                                max={cancelledShipments}
                                sx={
                                  cancelledShipments.toString().length > 3
                                    ? { padding: '0 15 0 0', marginLeft: 2 }
                                    : { padding: '0 20 0 0' }
                                }
                                badgeContent={cancelledShipments}
                                variant='standard'
                                color='error'
                              />
                            </div>
                            <div>Cancelled</div>
                          </div>
                          {...a11yProps(5)}
                        />
                      </Tabs>
                      {value === 1 && (
                        <Box sx={{ display: 'flex', gap: 1, mb: 1, ml: 0.5 }}>
                          <Chip
                            label='All'
                            clickable
                            variant={
                              tenderedSubFilter === 'all'
                                ? 'filled'
                                : 'outlined'
                            }
                            color={
                              tenderedSubFilter === 'all'
                                ? 'primary'
                                : 'default'
                            }
                            onClick={() => {
                              setTenderedSubFilter('all');
                              setViewShipmentsData([]);
                              setShipmentsLoader(true);
                              setNoRecordMsg('Loading ...');
                              setHasMore(true);
                              setPagination({ pageIndex: 1, pageSize: 20 });
                            }}
                            size='small'
                          />
                          <Chip
                            label='Approved For Booking'
                            clickable
                            variant={
                              tenderedSubFilter === 'approved'
                                ? 'filled'
                                : 'outlined'
                            }
                            color={
                              tenderedSubFilter === 'approved'
                                ? 'success'
                                : 'default'
                            }
                            onClick={() => {
                              setTenderedSubFilter('approved');
                              setViewShipmentsData([]);
                              setShipmentsLoader(true);
                              setNoRecordMsg('Loading ...');
                              setHasMore(true);
                              setPagination({ pageIndex: 1, pageSize: 20 });
                            }}
                            size='small'
                          />
                          <Chip
                            label='Not Approved'
                            clickable
                            variant={
                              tenderedSubFilter === 'notApproved'
                                ? 'filled'
                                : 'outlined'
                            }
                            color={
                              tenderedSubFilter === 'notApproved'
                                ? 'error'
                                : 'default'
                            }
                            onClick={() => {
                              setTenderedSubFilter('notApproved');
                              // setViewShipmentsData([]);
                              // setShipmentsLoader(true);
                              // setNoRecordMsg('Loading ...');
                              // setHasMore(true);
                              // setPagination({ pageIndex: 1, pageSize: 20 });
                            }}
                            size='small'
                          />
                        </Box>
                      )}
                    </Box>
                  )
                );
              }}
            />
          </div>
        </div>
      )}
    </>
  );
}
export default memo(ManageShipmentsTable);
